const languageObj = {
  "ra": {
    "action": {
      "send": "Enviar",
      "back_to_list": "Voltar à lista",
      "clear": "Limpar",
      "delete": "Excluir",
      "eliminate": "Eliminar",
      "show": "Mostrar",
      "list": "Listar",
      "save": "Salvar",
      "create": "Criar",
      "edit": "Editar",
      "sort": "Ordenar",
      "cancel": "Cancelar",
      "issuance": "Emitir",
      "undo": "Desfazer",
      "refresh": "Atualizar",
      "retry_send": "Reenviar envio",
      "accounting_entry": "Contabilizar",
      "add": "Adicionar",
      "remove": "Remover",
      "add_filter": "Adicionar filtro",
      "remove_filter": "Remover filtro",
      "back": "Voltar",
      "bulk_actions": "%{smart_count} selecionado",
      "all": "Todos",
      "all_promotions": "Todas as promoções",
      "export": "Exportar",
      "import": "Importar",
      "unselect": "Desmarcar",
      "confirm": "Confirmar",
      "add_specific": "Adicionar %{name}",
      "clear_input_value": "Limpar valor do formulário",
      "enable": "Habilitar",
      "disable": "Desabilitar",
      "actions": "Ações",
      "generate_payment": "Gerar pagamento",
      "search": "Buscar",
      "remove_all_filters": "Remover todos os filtros",
      "go_payment_types": "Ir para formas de pagamento",
      "pay": "Pagar",
      "authorize": "Autorizar",
      "reconcile": "Conciliar",
      "reprocess_conciliation": "Reprocessar conciliação",
      "reprocess_conciliation_item": "Reprocessar",
      "adjust_cost_sale": "Ajustar custo / venda",
      "force_reconcile": "Forçar conciliação",
      "unreconcile": "Não conciliar",
      "delete_line": "Excluir linha",
      "generate_op": "Gerar OP",
      "generate_invoice": "Gerar fatura",
      "unauthorize": "Desautorizar",
      "to_confirm": "Confirmar",
      "test_rule": "Testar Regra",
      "see_details": "Ver detalhes",
      "go_revision": "revisões",
      "clone": "Clonar %{name}",
      "generate": "Gerar",
      "generate_receipts": "Gerar recibos",
      "generate_receipt": "Gerar recibo",
      "generated": "Gerado",
      "acept": "Aceitar",
      "emit": "Emitir",
      "emit_status": "Emitido",
      "cancel_status": "Cancelado",
      "reimburse": "Reembolsar",
      "refund": "Reembolsar",
      "close": "Fechar",
      "see_conditions": "Ver condições",
      "see_conditions_provider": "Ver condições do fornecedor",
      "save_and_calculate_liquidation": "Salvar e calcular liquidação",
      "save_and_recalculate_liquidation": "Salvar e recalcular liquidação",
      "refresh_data": "Atualizar dados",
      "calculate_liquidation": "Calcular liquidação",
      "save_and_back_to_list": "Salvar e ir para a lista",
      "create_reservation": "Criar nova reserva",
      "guarantee": "Garantir",
      "move": "Mover",
      "apply_to_reservation": "Aplicar à reserva",
      "apply_to_item": "Aplicar aos itens",
      "finish_and_generate_receipt": "Finalizar e gerar recibo",
      "finish_without_generate_receipt": "Finalizar sem gerar recibo",
      "change_password": "Alterar senha",
      "update": "Atualizar",
      "see_something": "Ver %{thing}",
      "forward": "Reenviar",
      "forward_something": "Reenviar para %{something}",
      "continue": "Continuar",
      "regenerate_notification": "Regenerar notificação",
      "update_all_products": "Atualizar todos os produtos",
      "add_file": "Adicionar arquivo",
      "initCompleteProcess": "Iniciar Processo Completo",
      "initProcess": "Iniciar Processo",
      "preview": "Pré-visualizar",
      "update_rule_view": "Atualizar visualização",
      "finish": "Finalizar",
      "details": "Detalhes",
      "split": "Separar",
      "pay_with": "Pagar com %{name}",
      "void": "Anular",
      "select": "Selecionar",
      "select_with_dots": "Selecione...",
      "loading": "Carregando...",
      "loadingBusinessUnit": "Carregando unidades de negócio...",
      "loadingWorkUnit": "Carregando unidades de trabalho...",
      "filter": "Filtrar",
      "approve": "Aprovar",
      "refuse": "Recusar",
      "delete_business_in_tma": "Cancelar negócios no TMA",
      "hidden": "Disfarce",
      "addPaymentRecord": "Adicionar registro de pagamento",
      "addAnotherPaymentRecord": "Adicionar outro registro de pagamento",
      "addNewRetention": "Adicionar nova retenção",
      "removeRetention": "Remover retenção",
      "deleteRecord": "Excluir registro",
      "addMoreReservations": "Adicionar mais reservas",
      "addReservations": "Adicionar reserva",
      "registerPayment": "Registrar pagamento",
      "allocatePaymentToReservations": "Imputar pagamento às reservas",
      "searchReservations": "Buscar reservas",
      "downloadHistory": "Baixar histórico",
      "download": "Download",
      "download_file": "Baixar arquivo",
      "addNewRelation": "Adicionar uma nova relação",
      "addComponent": "Adicionar componente",
      "uploadAndReconcileStatement": "Carregar e conciliar extrato",
      "generateAndDownloadStatement": "Gerar e baixar extrato",
      "view_reservation": "Ver reserva",
      "add_comment": "Adicionar comentário",
      "unapply_payment": "Cancelar pagamento",
      "after_sales": "Pós-venda",
      "complementary_item": "Item complementar",
      "create_item_supplier": "Item fornecedor",
      "show_aftersales": "Mostrar item pós-venda",
      "hide_aftersales": "Ocultar item pós-venda",
      "register_return": "Registrar devolução",
      "view_retail_liquidation": "Ver liquidação de varejo",
      "new_message": "Nova mensagem",
      "added": "adicionou",
      "wrote": "escreveu",
      "view_history": "Ver histórico",
      "general_search": "Busca geral",
      "reply": "Responder",
      "return": "Retornar",
      "see_more": "Ver mais...",
      "see_less": "Ver menos",
      "generate_credit": "Gerar crédito",
      "add_reservation": "Adicionar reserva",
      "enable_online_payments": "Habilitar pagamentos online",
      "save_payment_instance": "Salvar instância de pagamento",
      "add_payment_method": "Adicionar método de pagamento",
      "reliquidate": "Reliquidar",
      "disable_rebooker": "Desativar rebooker",
      "apply_credits": "Aplicar créditos",
      "generate_record": "Gerar registro",
      "delete_payments": "Excluir pagamentos",
      "menu": "Menu",
      "get": "Obter",
      "query": "Query",
      "pricing": "Preços",
      "revision": "Revisão",
      "config": "Config",
      "full_edit_due_date": "Data de vencimento da edição completa",
      "optional": "Opcional",
      "show_codes": "Mostrar códigos",
      "chatbot": "Chatbot",
      "save_without_validate": "Salvar sem criar relações",
      "copy_formula": "Copiar fórmula",
      "copy_json": "Copiar JSON",
      "paste_formula": "Colar fórmula",
      "update_receipt": "Atualizar recibo",
      "view_cancel_supplier": "Ver Cancelacion Fornecedor",
      "generate_voucher": "Gerar voucher",
      "download_voucher": "Baixar voucher",
      "as_item_create": "Criar item de PV em nova reserva",
      "as_item_current_reserve": "Criar item PV nesta reserva",
      "calculate_costs": "Calcular custos",
      "invalidate": "Anular",
      "generate_on_demand": "Gerar sob demanda",
      "archive": "Arquivar",
      "apply": "Aplica"
    },
    "saved_queries": {
      "remove_label_with_name": "Remover query %{name}",
      "new_label": "Salvar query atual",
      "search": "Buscar",
      "remove_all_filters": "Remover todos os filtros",
      "go_revision": "revisões",
      "see_details": "Ver detalhes",
      "test_rule": "Testar"
    },
    "boolean": {
      "true": "Sim",
      "false": "Não"
    },
    "page": {
      "list": "Lista de %{name}",
      "edit": "%{name} #%{id}",
      "show": "%{name} #%{id}",
      "create": "Criar %{name}",
      "dashboard": "Painel",
      "not_found": "Não encontrado",
      "loading": "Carregando",
      "empty": "Página Vazia",
      "invite": "Crie o primeiro registro"
    },
    "input": {
      "file": {
        "upload_several": "Arraste alguns arquivos para começar o upload, ou clique aqui para selecioná-los.",
        "upload_single": "Arraste um arquivo para começar o upload, ou clique aqui para selecioná-lo."
      },
      "image": {
        "upload_several": "Arraste algumas imagens para começar o upload, ou clique aqui para selecioná-las.",
        "upload_single": "Arraste uma imagem para começar o upload, ou clique aqui para selecioná-la."
      },
      "references": {
        "all_missing": "Nenhuma referência encontrada.",
        "many_missing": "Pelo menos uma das referências associadas parece não estar disponível.",
        "single_missing": "A referência associada parece não estar disponível."
      },
      "password": {
        "toggle_hidden": "Mostrar / Ocultar"
      },
      "placeholder": {
        "search": "Pesquisar..."
      }
    },
    "message": {
      "complete_required_fields": "Preencha os campos obrigatórios.",
      "please_select_field": "Por favor selecione %{field}",
      "separate_by_comma": "Separar valores com vírgula",
      "disclaimer_billingform_all_amounts_are_expressed_value_selected_payment_currency_selected": "Todos os valores são expressos no valor da moeda de pagamento selecionada.",
      "extract_download_available": "Download do extrato disponível.",
      "extract_download_error": "A extração não existe no banco de dados.",
      "select_file": "Selecione o arquivo......",
      "upload_only_xlsx_files": "Carregar apenas arquivos .xlsx",
      "upload_documents_create_reconciliation": "Carregue documentos para criar reconciliação.",
      "select_fields_generate_extract_file": "Selecione os campos para gerar o arquivo de extração.",
      "route_config_import_description": "Importe um arquivo CSV com as rotas que deseja configurar. Cada linha deve incluir os campos origin, destination, days_of_week, date_start e date_end.",
      "route_config_import_success": "Foram importadas %{inserted} rotas.",
      "route_config_import_partial": "Foram importadas %{inserted} rotas. %{errors} linhas possuem erros.",
      "route_config_import_error": "Não foi possível importar o arquivo. Tente novamente.",
      "route_config_import_result": "Rotas importadas: %{inserted}. Erros: %{errors}.",
      "route_config_work_units_error": "Não foi possível carregar as unidades de trabalho.",
      "route_config_product_types_error": "Não foi possível carregar os tipos de produto.",
      "no_records_found": "Nenhum registro encontrado para exportar.",
      "no_records": "Nenhum registro",
      "permissions_required": "São necessárias permissões para acessar.",
      "billingform_cancellation_warning": "Se você está reportando o pagamento de uma reserva com cancelamento próximo ou imediato, recomendamos notificar o vendedor correspondente para garantir o serviço. Este módulo não envia notificações automáticas aos vendedores.",
      "billingform_reservation_warning": "Esses valores mostram as informações registradas no momento da criação do formulário de cobrança e não refletem seu status atual.",
      "yes": "Sim",
      "no_registry": "Sem itens carregados",
      "no_history": "Sem histórico disponível",
      "no_search_found": "Nenhuma correspondência encontrada",
      "yes_search_found": "Busca bem-sucedida",
      "no": "Não",
      "are_you_sure": "Você tem certeza?",
      "about": "Sobre",
      "not_found": "Página não encontrada",
      "loading": "A página está carregando, por favor, aguarde um momento",
      "invalid_form": "O formulário não é válido, por favor, corrija os possíveis erros",
      "delete_title": "Excluir %{resource} %{name}",
      "delete_content": "Você tem certeza de que deseja excluir este item?",
      "confirm_authorize": "Você tem certeza de que deseja autorizar esta ordem de pagamento?",
      "confirm_unauthorize": "Você tem certeza de que deseja desautorizar esta ordem de pagamento?",
      "generate_client_title": "Gerar cliente",
      "update_items_title": "Atualizar itens",
      "import_invoice_title": "Importar fatura",
      "import_receipt_title": "Importar recibo",
      "delete_invoice_title": "Excluir fatura",
      "confirm_creation_sale_title": "Confirmar criação do negócio no TMA",
      "confirm_creation_sale_content": "O negócio foi criado corretamente no TMA?",
      "confirm_add_items_title": "Confirmar adição de itens no TMA",
      "confirm_add_items_content": "Os itens foram adicionados corretamente no TMA?",
      "init_complete_process": "Iniciar processo completo",
      "generate_sale_title": "Gerar negócio",
      "delete_sale_title": "Excluir negócio",
      "add_items_title": "Adicionar itens",
      "generate_invoice_title": "Gerar fatura",
      "generate_receipt_title": "Gerar recibo",
      "generate_receipts_title": "Gerar recibos",
      "cancel_receipt_title": "Anular recibo",
      "delete_transaction_title": "Excluir transação",
      "delete_payment_reservation": "Excluir pagamento",
      "confirm_action_content": "Você tem certeza de que deseja realizar esta ação?",
      "bulk_delete_title": "Excluir %{name} |||| Excluir %{smart_count} itens de %{name}",
      "bulk_delete_content": "Você tem certeza de que deseja excluir este %{name}? |||| Você tem certeza de que deseja excluir estes %{smart_count} itens?",
      "unsaved_changes": "Há alterações não salvas",
      "configuration": "Configuração de %{name}",
      "unmatch_amount_to_pay": "O valor total inserido não é suficiente para cobrir os itens selecionados",
      "reservation_item_not_found": "O item da reserva não foi encontrado",
      "has_not_currencies_by_business_unit": "A unidade de trabalho selecionada não possui moedas disponíveis, por favor selecione outra",
      "credit_in_favor_message": "O montante total de pagamentos sem custos adicionais equivalente a %{type_currency} $ %{total_amount} é superior ao valor total dos itens selecionados %{type_currency} $ %{item_total_amount}, deseja registrar a diferença %{type_currency} $ %{rest_amount} como \"pagamento a conta\"?",
      "validate_amount_to_use": "O valor a ser utilizado excede o valor total",
      "credit_in_favor_item_message": "O valor a pagar %{currency} %{total_amount} é superior ao valor pendente do item selecionado %{currency} %{item_total_amount}, deseja registrar a diferença %{currency} %{rest_amount} como \"pagamento a conta\"?",
      "all_route": "Para não discriminar por uma rota específica, escreva a palavra \"todas\".",
      "invalid_format": "O formato é inválido",
      "format_route": "O formato da rota deve ser assim \"XXX-XXX\", por exemplo, \"BUE-MIA\", \"CBA-MDA\"",
      "error_formula": "Desculpe, houve um problema ao resolver a fórmula! Por favor, tente novamente!",
      "number_input": "A prioridade aumenta quanto maior for o número, 1 é a prioridade mínima e 100.000 a máxima",
      "combine_formula_error": "Não foi possível combinar a fórmula com a fórmula da regra pai",
      "cobine_formula_success": "A fórmula foi combinada com a da regra pai",
      "cobine_formula_remove": "A combinação da fórmula com a da regra pai foi removida",
      "already_used": "%{name} já está em uso",
      "desglose_var": "Esta variável será exibida no detalhamento",
      "desglose_rule_types_var": "Esta variável será exibida no detalhamento (%{ruleTypes})",
      "global_variable": "Variável global",
      "global_variable_and_show": "Esta variável global será exibida no detalhamento",
      "sitio_var": "Esta variável será exibida no site",
      "desglose_and_sitio_var": "Esta variável será exibida no site e no detalhamento",
      "desglose_rule_types_and_sitio_var": "Esta variável será exibida no site e no detalhamento (%{ruleTypes})",
      "acept": "Aceitar",
      "cancel_item_reserva": "Você tem certeza de que deseja cancelar esta reserva %{reserva}?",
      "cancel_status_item_reserva": "Você tem certeza de que deseja alterar o status da reserva %{reserva} para CANCELADO?",
      "cancel_train_segment_reserva": "Você tem certeza de que deseja cancelar esta reserva %{reserva}? O custo a pagar pelo cancelamento será de %{currency} %{cost}",
      "delete_item_reserva": "Você tem certeza de que deseja excluir o item %{item}?",
      "guarantee_item_reserva": "Você tem certeza de que deseja garantir o item %{item}?",
      "cancel_item_segment": "Você tem certeza de que deseja cancelar este trecho %{segment}? O custo a pagar pelo cancelamento será de %{currency} %{cost}",
      "delete_item_segment": "Você tem certeza de que deseja excluir este trecho %{segment}?",
      "emit_item_reserva": "Você tem certeza de que deseja emitir esta reserva %{reserva}?",
      "emit_status_item_reserva": "Você tem certeza de que deseja alterar o status da reserva %{reserva} para EMITIDO?",
      "refresh_retrive_item_reserva": "Você tem certeza de que deseja atualizar a reserva %{reserva}?",
      "rule_not_apply": "A regra de %{rule} não foi aplicada corretamente",
      "error_create_item": "Ocorreu um erro ao criar o produto",
      "error_update_item": "Ocorreu um erro ao editar o produto",
      "success_create_item": "O produto foi criado com sucesso",
      "success_edit_item": "O produto foi editado com sucesso",
      "delete_currency": "Você tem certeza de que deseja excluir esta moeda? Ela será excluída permanentemente",
      "delete_product": "Você tem certeza de que deseja excluir este produto? Ele será excluído permanentemente",
      "delete_email": "Você tem certeza de que deseja excluir este email? Ele será excluído permanentemente",
      "delete_banner": "Você tem certeza de que deseja excluir este banner? Ele será excluído permanentemente",
      "delete_landing": "Você tem certeza de que deseja excluir esta landing? Ela será excluída permanentemente",
      "delete_sector": "Você tem certeza de que deseja excluir este setor? Ele será excluído permanentemente",
      "integrity_error": "Não foi possível excluir porque este registro faz parte de outro registro",
      "total_payment_in": "Total a pagar em ",
      "subtotal_in": "Subtotal em ",
      "filter_by_work_unit": "Filtrar por Unidade de Trabalho",
      "filter_by_business_unit": "Filtrar por Unidade de Negócio",
      "filter_by_seller": "Filtrar por Vendedor",
      "export_success": "Solicitação recebida, o arquivo será enviado para o email %{email} em breve...",
      "export_error": "Erro ao solicitar os dados",
      "import_success": "Os dados foram importados com sucesso",
      "import_error": "Erro ao importar dados",
      "supplier_error": "Erro ao solicitar os fornecedores",
      "enter_data_manually": "Inserir dados manualmente",
      "retrieve_supplier_data": "Recuperar dados do fornecedor",
      "get_available_tickets": "Obter tickets disponíveis",
      "change_password_title": "Alterar senha",
      "invalid_password": "Senha inválida",
      "no_have_credits": "Você não tem créditos disponíveis",
      "reservation_found": "A reserva %{reservation_number} foi encontrada",
      "reservation_not_found": "A reserva %{reservation_number} NÃO foi encontrada",
      "reservation_payment_generate_success": "O pagamento da reserva %{reservation_number} foi registrado com sucesso!",
      "reservation_payment_generate_error": "O pagamento da reserva %{reservation_number} NÃO foi registrado!",
      "negative_amount_error": "O valor a ser aplicado não pode ser negativo",
      "item_payment_generate_success": "Pagamento registrado com sucesso.",
      "item_payment_generate_error": "Não foi possível registrar o pagamento.",
      "add_glosa_title": "Adicionar texto",
      "add_glosa_content": "Deseja adicionar um texto à fatura?",
      "optional": "Opcional",
      "non_refundable": "Item não reembolsável",
      "always_cheapest": "Sempre o mais barato?",
      "transaction_detail_title": "Detalhe da transação",
      "sure_to_clone": "Você tem certeza de que deseja clonar esta/este %{entity}?",
      "rule_error": "Erro na regra de liquidação",
      "clone_reservation": "Você tem certeza de que deseja clonar esta reserva %{reserva}?",
      "force_cancel": "Houve um erro no cancelamento, deseja forçar a alteração de status para CANCELADO?",
      "invalid_cuit": "CUIT inválido",
      "valid_characters": "Digite pelo menos %{num} caracteres para buscar",
      "error_to_delete_formula_global_variables": "Erro ao excluir %{name}, você deve primeiro remover as variáveis das seguintes regras",
      "transaction_refund_success": "A transação foi reembolsada com sucesso.",
      "transaction_refund_error": "Houve um erro ao reembolsar a transação",
      "capture_payment_success": "O pagamento foi capturado com sucesso.",
      "capture_payment_error": "Houve um erro ao capturar o pagamento.",
      "refund_transaction_title": "Reembolsar transação",
      "capture_payment_title": "Capturar pagamento",
      "confirm_separation": "Você tem certeza de que deseja separar os/o passageiros/passageiro?",
      "ivalid_amount_passenger": "A soma total do valor por passageiro (%{passenger_amount}) excede o valor total do pagamento (%{payment_type_amount})",
      "refresh_void_item_reserva": "Você tem certeza de que deseja anular a reserva %{reserva}?",
      "not_found_imagen_size": "Imagem não encontrada com as extensões fornecidas.",
      "field_to_calculate_liquidation": "Para calcular a liquidação, é necessário preencher os seguintes campos: Fonte, Moeda, Fornecedor, Líquido do Fornecedor, Destino, Tipo de Destino e Início do Serviço.",
      "delete_date_rate": "Tem certeza de que deseja excluir este intervalo de datas? Será excluído permanentemente.",
      "delete_due_date_method": "Tem certeza de que deseja remover este modelo de expiração? Será excluído permanentemente",
      "no_data": "No há dados",
      "has_no_children": "Não tem filhos",
      "no_options_availble": "Não há opções disponíveis",
      "no_passenger": "Não há passageiros",
      "no_content_to_display": "Não há conteúdo para mostrar",
      "email_sent_to": "Email enviado para:",
      "product_value_assignment_text": "Digite o código JSON dos produtos no campo *%{json_product}* para carregar o conteúdo de*JSON*. Selecione uma fonte de dados em *%{detail_table}%* para carregar o conteúdo de *tableName*. Finalmente, selecione na tabela *JSON* os valores que deseja associar em *tableName*, fazendo a seleção no valor de *tableName* que deseja atribuí-lo.",
      "select_option": "Selecione uma opção:",
      "rule_formula_explantion": "Para mover fórmulas entre páginas, selecione a fórmula que deseja mover. Sem soltar a fórmula, mova o mouse até a página para onde deseja movê-la. A página mudará automaticamente e você poderá posicionar a fórmula no local desejado.",
      "select_at_least": "Selecione pelo menos %{num} caracteres",
      "enter_at_least": "Insira pelo menos %{num} caracteres",
      "select_at_least_one_element": "Selecione pelo menos um elemento",
      "instructive_work_unit_select": "*Se desejar selecionar várias opções, só é possível selecionar unidades de trabalho do mesmo nível.",
      "instructive_paymen_type": "Apertando \"Adicionar métodos de pagamento\", você poderá selecionar o tipo de pagamento que deseja utilizar.",
      "ref_site": "Nome de referência do site",
      "approve_fraud": "Tem certeza de que deseja aprovar a análise de fraude?",
      "refuse_fraud": "Tem certeza de que deseja recusar a análise de fraude?",
      "my_devices_duration_message": "Você está conectado a esses dispositivos ou fez login neles nos últimos 30 dias. Podem aparecer várias sessões do mesmo dispositivo.",
      "one_session_active": "1 sessão em um",
      "your_current_session": "Sua sessão atual",
      "logout_device": "Tem certeza de que deseja remover este dispositivo %{device}?",
      "device_disabled_success": "O dispositivo foi removido com sucesso!",
      "device_disabled_error": "Houve um erro ao remover o dispositivo.",
      "generates_multiple_receipt_success": "O recibo foi gerado corretamente.",
      "generates_multiple_receipt_error": "Ocorreu um erro ao gerar o recibo.",
      "no_details_available": "Nenhum detalhe disponível",
      "error_to_load_details": "Ocorreu um erro ao carregar os detalhes",
      "delete_business_TMA_message": "Esta ação permite que os itens sejam baixados de volta para o TMA",
      "delete_business_action_TMA_message": "Esta ação cancela o negócio no TMA e os itens que ele contém",
      "import_credit_note_title": "Nota de crédito de importação",
      "generate_credit_note_title": "Gerar nota de crédito",
      "error_RUT": "RUT digitado incorretamente, deve conter até 12 caracteres",
      "error_CUIT": "CUIT inserido incorretamente",
      "number_exist": "O número digitado já existe",
      "billing_error": "Ocorreu um erro ao processar o faturamento",
      "success_payment_and_receipt_error": "O pagamento foi registrado, mas o recebimento falhou.",
      "paymentMethodNotConfigured": "Este meio de pagamento ainda não foi configurado, por favor, entre em contato com o suporte.",
      "noFilesUploaded": "Nenhum arquivo carregado",
      "noReservationsSelected": "Ainda não há reservas selecionadas",
      "noOpenReservationsFound": "Não foram encontradas reservas com status aberto",
      "enableFilter": "Ative o filtro para listar as reservas com status aberto disponíveis",
      "unavailable": "Indisponível",
      "noInformationAvailable": "Nenhuma informação disponível.",
      "completed": "Concluído",
      "attention": "Atenção",
      "confirmOrEditData": "A seguir, você pode confirmar os dados inseridos anteriormente ou voltar ao formulário para fazer alterações.",
      "paymentRegisteredSuccess": "Pagamento registrado com sucesso!",
      "paymentAppliedToReservations": "O pagamento foi aplicado corretamente às reservas selecionadas",
      "paymentRegistrationError": "Erro ao registrar o pagamentot",
      "tryAgain": "Por favor, tente novamente.",
      "noResultsAvailable": "Não há resultados disponíveis",
      "createRelationsBetweenCurrenciesAndBases": "Você precisa criar as seguintes relações entre moedas e bases para continuar",
      "beforeDeleting": "Antes de excluir",
      "deleteCurrencyBaseConfirmation": "Você tem certeza de que deseja excluir esta configuração de moeda-base?",
      "assignedMultipleTimesInRelationship": "está atribuída mais de uma vez na relação",
      "incompleteRelationshipBetween": "Falta completar a relação entre",
      "forTheRelationship": "Para a relação",
      "missingFollowingBases": "Faltam as seguintes bases",
      "theRelationshipBetween": "A relação entre",
      "noAssignedValue": "não tem um valor atribuído",
      "missingValuesForBases": "faltam atribuir os valores às bases",
      "changesAppliedSuccessfully": "Alterações aplicadas com sucesso, por favor, execute o salvamento novamente",
      "paymentRegistrationExchangeRateError": "Não é possível continuar com o registro do pagamento, pois não existe uma taxa de câmbio para a data ",
      "contactSupportMessage": "Por favor, entre em contato com o suporte.",
      "invalid_json": "JSON inválido",
      "enter_json": "Insira o JSON",
      "copy_to_clipboard": "Copiar para a área de transferência",
      "reservation_to_without_business": "A reserva selecionada não possui um negócio gerado. Por favor, gere um negócio na reserva selecionada ou escolha outra reserva para mover os créditos.",
      "reservation_from_without_business": "A reserva atual não possui um negócio gerado. Por favor, gere um negócio na reserva atual para mover os créditos para outra reserva.",
      "amount_exceeds_unused": "O valor excede o valor total de créditos (%{amount_credit}).",
      "generate_provider_order": "Geração de ordem de pagamento de fornecedor",
      "delete_comment": "Tem certeza de que deseja excluir este comentário?",
      "pending_amount_error": "Erro: Ainda há saldo pendente a ser imputado.",
      "allocation_amount_error": "Erro: A imputação é maior que o valor pago.",
      "delete_requirement": "Tem certeza de que deseja excluir este requerimento?",
      "delete_requirement_success": "Requerimento excluído com sucesso",
      "delete_requirement_error": "Ocorreu um erro ao excluir o requerimento",
      "amount_to_pay_error_min": "A soma dos valores a pagar não pode ser menor que o total",
      "download_export_success": "Arquivo exportado com sucesso.",
      "view_refound_amount": "Ver penalidade do reembolso",
      "generate_supplier_payment_order": "Gerar ordem de pagamento fornecedor",
      "generate_client_payment_order": "Gerar ordem de pagamento cliente",
      "register_return": "Tem certeza de que deseja registrar a devolução do item?",
      "assigned": "Atribuído",
      "watched": "Observadas",
      "created": "Criadas",
      "after_sales": "Tem certeza de que deseja realizar o pós-venda da reserva %{reserva}?",
      "edit_notification_success": "Notificação editada com sucesso",
      "edit_notification_error": "Ocorreu um erro ao editar a notificação",
      "delete_notification_confirm": "Tem certeza de que deseja excluir a notificação?",
      "delete_notification_success": "Notificação excluída com sucesso",
      "delete_notification_error": "Ocorreu um erro ao excluir a notificação",
      "change_status": "mudou o estado para %{status}",
      "change_status_error": "Houve um erro ao alterar o status da reserva",
      "added_reservation": "adicionou a reserva %{reservation}",
      "removed_reservation": "removeu reservation %{reservation}",
      "changed_subject": "atualizou o assunto para \"%{subject}\"",
      "changed_description": "atualizou a descrição para \"%{description}\"",
      "assign_item": "atribuiu o item \"%{item}\"",
      "changed_type": "atualizou o tipo para \"%{type}\"",
      "file_added": "adicionou o arquivo \"%{file}\"",
      "file_removed": "removeu o arquivo\"%{file}\"",
      "and": "e",
      "updated_notification": "atualizei a notificação",
      "notification_not_found": "A notificação não foi encontrada",
      "assigned_to": "atribuiu a %{user}",
      "changed_priority": "alterou a prioridade de %{old_priority} para %{new_priority}",
      "notification_filter_error": "Ocorreu um erro ao filtrar as notificações",
      "unapply_payment": "Tem certeza de que deseja desfazer o pagamento?",
      "unapply_payment_success": "Pagamento desfeito com sucesso",
      "unapply_payment_error": "Ocorreu um erro ao desfazer o pagamento",
      "return_success": "Valor devolvido com sucesso",
      "return_error": "Ocorreu um erro ao devolver o valor",
      "payment_found": "O item não pode ser movido porque há um pagamento aplicado",
      "payment_found_delete": "O item não pode ser excluído porque há um pagamento aplicado",
      "update_status_error": "Não foi possível alterar o status",
      "changed_tracker_id": "mudou o tracker id para %{new_tracker_id}",
      "added_link": "mudou o link das reservas %{new_link}",
      "credit_generated_success": "Crédito gerado com sucesso",
      "credit_generated_error": "Não foi possível gerar o crédito",
      "due_tooltip": "Ative ou desative esta seção para ver apenas as reservas vencidas no Detalhe por Reserva",
      "to_due_tooltip": "Ative ou desative esta seção para ver apenas as reservas a vencer no Detalhe por Reserva",
      "credits_tooltip": "Clique aqui para ir ao Detalhe por Reserva de créditos",
      "unapply_confirmation": "Deseja desaplicar a transação com o valor de %{currency} %{amount}?",
      "up_to_date": "Você está em dia",
      "unapply_payment_item": "Deseja desaplicar o pagamento aplicado ao item %{description}?",
      "notification_redirect_error": "Notificação associada a várias reservas; não é possível usar o atalho para elas. Isso só será possível quando a mensagem estiver associada a uma única reserva.",
      "amount_to_pay_error": "A soma dos valores a pagar não pode ser maior que o total",
      "open_status": "Tem certeza de que deseja alterar o status da reserva %{reserva} para ABERTA?",
      "edit_report_success": "Relatório editado com sucesso",
      "edit_report_error": "Ocorreu um erro ao editar o relatório",
      "create_report_success": "Relatório criado com sucesso",
      "create_report_error": "Ocorreu um erro ao criar o relatório",
      "confirmation_delete_paymentes_product": "Tem certeza de que deseja excluir as instâncias de pagamento associadas ao produto %{product}?",
      "payment_product_decription": "Configure as instâncias de pagamento por produto",
      "payment_instance_deleted": "Instância de pagamento excluída com sucesso",
      "payment_instance_delete_error": "Ocorreu um erro ao excluir a instância de pagamento",
      "every_day": "Todos os dias",
      "amount_to_pay_requiered": "O valor a pagar é obrigatório",
      "detailed_by_item": "Detalhado por item",
      "general_detailed": "Detalhado geral",
      "preconfigured": "Pré-configurado",
      "on_demand_date": "Sob demanda - Por datas",
      "on_demand_reserve": "Sob demanda - Por número da reserva",
      "on_demand": "Sob demanda",
      "daily": "Diária",
      "weekly": "Semanal",
      "monthly": "Mensal",
      "yesterday": "Ontem",
      "last_days": "Últimos 7 dias",
      "current_week": "Esta semana",
      "last_week": "Semana passada",
      "current_month": "Este mês",
      "last_month": "Mês passado",
      "current_quarter": "Este trimestre",
      "previous_quarter": "Trimestre anterior",
      "current_year": "Este ano",
      "last_year": "Ano passado",
      "year_to_date": "Ano atual até hoje",
      "month_to_date": "Mês atual até hoje",
      "week_to_date": "Semana atual até hoje",
      "unique": "Única",
      "commercial": "Comercial",
      "payment_allocation": "Imputação de pagamento",
      "reserve_control": "Controle de reservas",
      "journal_entry_control": "Controle de lançamento contábil",
      "accounting_control": "Controle contábil",
      "confirm_delete_report": "Tem certeza de que deseja excluir o relatório %{name}?",
      "scheduled": "Programado",
      "summarized": "Resumido",
      "uniqueDateValidation": "Amanhã é a primeira data disponível para o envio de relatórios \"Pré-configurados\". Crie um relatório \"Sob demanda\" se precisar recebê-lo agora.",
      "onDemandDateAclaration": "O período máximo de análise para relatórios 'Sob demanda - Por datas' é de 2 meses.",
      "reliquidation_error": "Ocorreu um erro na reliquidação",
      "reliquidation_confirm": "Tem certeza de que deseja executar a reliquidação %{liquidation}?",
      "delete_items_title": "Eliminar itens",
      "disable_rebooker_confirmation": "Tem certeza de que deseja desativar o rebooker?",
      "collection": "Cobrança",
      "supplier": "Fornecedor",
      "sales": "Vendas",
      "account_state": "Extrato da conta",
      "smartbook": "Smartbook",
      "metasearch": "Metasearch",
      "reservation_B2C": "reservas",
      "client": "Client",
      "delete_chat_bot": "Tem certeza de que deseja apagar toda a conversa? Essa ação é irreversível.",
      "confirmation_apply_credits": "Tem certeza de que deseja aplicar todos os créditos da reserva aos seus itens?",
      "confirm_delete": "Sim, apaga",
      "update_confirmation": "Tem certeza de que deseja atualizar as informações?",
      "undefined": "indefinido",
      "init_process_confirmation": "Tem certeza de que deseja iniciar o processo?",
      "client_tooltip": "Selecione na lista o Cliente com o qual deseja fazer login",
      "client_change_confirmation": "Tem certeza de que deseja mudar de cliente?",
      "delete_payments_message": "Você tem certeza de que deseja excluir os pagamentos?",
      "commercial_detail": "Cobranças Detalhadas",
      "billing_mexico": "Faturação México",
      "auto_bill_odoo_condition": "Faturação Automático en Odoo",
      "auto_bill_guaranteed_odoo": "Faturamento Terrestre de Itens Garantidos en Odoo",
      "hepstar": "Hepstar",
      "auto_bill_b2c_condition": "Faturamento B2C Automático",
      "auto_bill_condition": "Faturamento Automático",
      "auto_bill_guaranteed_condition": "Faturamento Automático de Itens Garantidos",
      "auto_bill_isbillable_condition": "Faturamento Automático de Itens Prontos para Faturar",
      "auto_bill_land_condition": "Faturamento Terrestre Automático",
      "auto_bill_payment_condition": "Faturamento Automático de Itens Pagos",
      "auto_create_billing_condition": "Criação Automática de Itens",
      "auto_create_land_condition": "Criação Automática de Itens Terrestres",
      "auto_create_with_is_billable": "Criação Automática de Itens Prontos para Faturar",
      "no_client_mirror": "Não existe um mirror para este cliente",
      "on_demand_logs": "Sob demanda - Logs",
      "preconfigured_logs": "Pré-configurado - Logs",
      "on_demand_account_state": "Sob demanda - Extrato da conta",
      "preconfigured_account_state": "Pré-configurado - Extrato da conta",
      "external_account_state": "Extrato de conta externo",
      "permission_tooltip": "Passe o cursor sobre a permissão para ver sua descrição",
      "accrued_billing_mexico": "Faturamento Mexico Acumulado",
      "delete_condition_confirmation": "Tem certeza de que deseja excluir a condição?",
      "new_after_sales_item_confirmation": "Tem certeza de que deseja criar um item de pós-venda em uma nova reserva?",
      "delete_bank_extract": "Tem certeza de que deseja excluir a movimentação bancária?",
      "pending_business_unit": "Pendente de atribuição de Unidade de Negócio à Reserva",
      "invalid_amount": "Valor inválido",
      "invalidate_document": "Tem certeza de que deseja cancelar o documento?",
      "select_product_type_report": "Selecione um tipo de produto para gerar um relatório",
      "reliquidation_error_rule": "Falha no recálculo. Nenhuma regra aplicável foi encontrada",
      "autocomplete_field": "Completa-se automaticamente",
      "select_supplier_to_search": "Selecione um fornecedor para ver os itens disponíveis",
      "invalidate_provision": "Você confirma o cancelamento da seguinte promoção?",
      "delete_file_message": "Tem certeza de que deseja excluir o anexo?",
      "max_characters": "Comprimento máximo: %{characters} caracteres",
      "complementary_item_success": "Item complementar criado com sucesso.",
      "complementary_item_error": "Erro ao criar item complementar.",
      "no_item_to_link_complementary": "Nenhum item válido encontrado para vincular o item complementar.",
      "multiple_email_separated_comma": "Permite adicionar mais de um e-mail, separados por vírgulas sem espaços",
      "installment_import_error_details_title": "Detalhe dos erros de importacao",
      "installment_import_error_line": "Linha %{line}",
      "installment_import_error_field": "Campo \"%{field}\": %{error}",
      "approve_debin": "Tem certeza de que deseja aprovar a transação com o Debin?",
      "refuse_debin": "Tem certeza de que deseja rejeitar a transação Debin?",
      "add_notification": "%{user} adicionou a notificação"
    },
    "navigation": {
      "no_results": "Nenhum resultado encontrado",
      "no_results_filters": "Nenhum resultado encontrado. Tente alterar os filtros.",
      "no_more_results": "A página número %{page} está fora dos limites. Tente a página anterior.",
      "page_out_of_boundaries": "A página número %{page} está fora dos limites",
      "page_out_from_end": "Não é possível navegar após a última página",
      "page_out_from_begin": "Não é possível navegar antes da página 1",
      "page_range_info": "%{offsetBegin}-%{offsetEnd} de %{total}",
      "page_range_info_billingform": "Página %{page} de %{totalPages}",
      "next": "Próximo",
      "prev": "Anterior",
      "page_rows_per_page": "Linhas por página",
      "skip_nav": "Pular",
      "of": "De",
      "page": "Página"
    },
    "auth": {
      "username": "Usuário",
      "user_menu": "Usuário",
      "password": "Senha",
      "login": "Entrar",
      "sign_in_error": "Erro de autenticação, por favor, tente novamente",
      "sign_in": "Entrar",
      "logout": "Sair",
      "forbidden": "Sua sessão expirou, por favor, faça login novamente",
      "auth_check_error": "Você precisa estar logado para acessar esta visualização",
      "recover_password": "Recuperar senha",
      "recover_password_success": "Um email foi enviado para recuperar a senha",
      "badrequest": "Erro na solicitação",
      "unauthorized": "Erro de autorização",
      "unknown": "Erro do servidor",
      "device_not_found": "Você entrou a partir de um novo dispositivo. Por favor, verifique seu e-mail e insira o código.",
      "sign_in_to_different_account": "Entrar em uma conta diferente",
      "device_code_invalid": "O código não é válido. Por favor, insira-o novamente.",
      "device_code_missing": "Por favor, verifique seu e-mail e valide seu acesso.",
      "device_code": "Código de verificação",
      "check_your_inbox": "Verifique sua caixa de entrada",
      "enter_device_code": "Enviamos um link de acesso seguro para %{mail} para que você possa entrar novamente.",
      "user_disabled": "Você excedeu o número de tentativas, será necessário redefinir a senha para continuar",
      "device_code_expired": "O código expirou. Um novo será enviado, por favor, verifique seu e-mail.",
      "device_with_expired_session": "A sessão expirou. Por favor, verifique seu e-mail e insira o código.",
      "reset_password": "Você excedeu o número de tentativas. Por segurança, alteramos sua senha, e você poderá visualizá-la no seu e-mail.",
      "username_exists": "O nome de usuário já está em uso."
    },
    "status": {
      "CANCELLED": "CANCELADO",
      "CANCELLED_COST": "CANCELADO COM DESPESAS",
      "CANCELED": "CANCELADO",
      "CANCEL_PROVIDER": "CANCELADO PELO FORNECEDOR",
      "PENDING": "PENDENTE DE EMISSÃO",
      "PENDING_BILLING": "PENDENTE",
      "CONFIRMED": "CONFIRMADO",
      "INVOICED": "EMITIDO",
      "NOT_INVOICED": "NÃO EMITIDO",
      "REFUNDED": "REEMBOLSADO",
      "PARTIAL_REFUND": "PARCIALMENTE REEMBOLSADO",
      "OPEN": "ABERTA",
      "CLOSED": "FECHADA",
      "DELETED_FEM": "ELIMINADA",
      "EXPIRED": "EXPIRADA",
      "EXPIRED_MALE": "EXPIRADO",
      "REFUND_IN_PROGRESS": "REEMBOLSO EM PROGRESSO",
      "INVOICE_IN_PROGRESS": "EMISSÃO EM PROGRESSO",
      "INVOICE_REQUESTED": "SOLICITAÇÃO DE EMISSÃO",
      "CANCELLATION_IN_PROGRESS": "CANCELAMENTO EM PROGRESSO",
      "VOID_IN_PROGRESS": "VOID EM PROGRESSO",
      "PROCESSING": "EMISSÃO EM PROCESSO",
      "PAID": "PAGO",
      "UNPAID": "PENDENTE DE PAGAMENTO",
      "PARTIALLY_PAID": "PARCIALMENTE PAGO",
      "NOT_REQUIRED": "NÃO REQUERIDO",
      "GUARANTEED": "GARANTIDO",
      "IN_REVIEW": "EM REVISÃO",
      "REJECTED": "REJEITADA",
      "REJECTED_MALE": "REJEITADO",
      "PENDING_RESERVATION": "PENDENTE DE RESERVA",
      "VOID": "ANULADO",
      "REINVOICED": "REENVIADO",
      "PARTIAL_INVOICED": "EMITIDO PARCIAL",
      "DELETED": "EXCLUÍDO",
      "CREATED": "CRIADO",
      "null": "-",
      "undefined": "INDEFINIDO",
      "ISSUED": "EMITIDA",
      "PREBOOKED": "PREBOOKED",
      "BILLED": "FATURADO",
      "SENT": "ENVIADO",
      "NOT REQUIRED": "NÃO REQUERIDO",
      "IN RSV": "EM RESERVA",
      "DEFEATED": "VENCIDO",
      "DUE": "A VENCER",
      "ERROR": "ERROR",
      "TO_BILLING": "PARA FATURAR",
      "APPROVED": "APROVADO",
      "MANUALLY_APPROVED": "APROVADO MANUALMENTE",
      "MANUALLY_DISAPPROVED": "REPROVADO MANUALMENTE",
      "FRAUD_ANALYSIS": "ANÁLISE DE FRAUDE",
      "DUE_TODAY": "EXPIRA HOJE",
      "FAILED_INVOICED": "EMISSÃO FALHADA",
      "status_entered": "Ingressou",
      "status_review": "Revisão",
      "status_rejected": "Recusou",
      "status_aproved": "Aprovado",
      "status_aproved_partially": "Parcialmente aprovado",
      "ON_SITE": "NO LOCAL",
      "PENDING_OPERATION": "OPERAÇÕES",
      "INIT_CHECKOUT": "SOLICITAÇÃO CRIADA",
      "open": "Aberto",
      "open_fem": "Aberta",
      "closed": "Fechado",
      "closed_fem": "Fechada",
      "processing": "Em Processamento",
      "deleted": "Excluído",
      "deleted_fem": "Excluída",
      "reconciled": "Conciliado",
      "completed": "Concluído",
      "completed_fem": "Concluída",
      "CROSSELL_SELECTED": "SOLICITAÇÃO CROSSELL",
      "FLIGHT_BOOKING_COMPLETED": "AÉREO CRIADO",
      "FRAUD_REVITION": "FRAUDE EM REVISÃO",
      "PAYMENT_IN_PROCESS": "PAGAMENTO EM PROCESSO",
      "SESSION_EXPIRED": "SESSÃO EXPIRADA",
      "CASH_PAYMENT_ABANDONED": "ABANDONO PAGAMENTO EM DINHEIRO",
      "BOOKING_REJECTED": "RESERVA FALHADA",
      "PAYMENT_REJECTED": "PAGAMENTO FALHADO",
      "FRAUD": "FRAUDE",
      "PAID_WITHOUR_FEE": "PAGO SEM TAXA",
      "CASH_PAYMENT": "PAGAMENTO EM DINHEIRO",
      "NOT_AVAILABILITY": "ERRO DE DISPONIBILIDADE",
      "PREBOOKING_FAILED": "PRÉ-RESERVA FALHADO",
      "RESERVED": "RESERVADA",
      "DUPLICATED": "DUPLICADO",
      "IN_PROCESS": "EM PROCESSO",
      "FINALIZED": "CONCLUÍDA",
      "FINISHED": "CONCLUÍDO",
      "AFTER_SALES": "PÓS-VENDA",
      "AFTER_SALES_HIDDEN": "PÓS-VENDA",
      "CREDIT_GENERATED": "CRÉDITO GERADO",
      "CREDIT_NOT_GENERATED": "CRÉDITO NÃO GERADO",
      "CREDIT_APPLIED": "CRÉDITO APLICADO",
      "UNAPPLIED": "DESAPLICADO",
      "APPLIED": "APLICADO",
      "PARTIALLY_APPLIED": "PARCIALMENTE APLICADO",
      "CONFIRMED_UNAPPLIED": "CONFIRMADO-",
      "PRE-RESERVATION": "PRE-RESERVA",
      "ON_REQUEST": "ON REQUEST",
      "REQUESTED": "SOLICITADA",
      "IN_PROGRESS": "EM PROGRESSO",
      "AVAILABLE": "DISPONÍVEL",
      "PAGO": "PAGAMENTO",
      "PENDIENTE_EMISION": "PENDENTE EMISSÃO",
      "EMITIDO": "EMITIDO",
      "SOLICITUD_EMISION": "SOLICITAÇÃO DE EMISSÃO",
      "EMISION_FALLIDA": "EMISSÃO FALHADA",
      "INVALIDATED": "ANULADA",
      "GENERATED": "GERADA",
      "USED": "USADO",
      "UNDEFINED": "NÃO DEFINIDO",
      "active": "ATIVA",
      "inactive": "INATIVA",
      "SESSION_CLOSED": "SESSÃO FECHADA",
      "DUPLICATED_RECOVERED": "DUPLICADO - RECUPERADO"
    },
    "title": {
      "filters": "Filtros",
      "create_user": "Criar um usuário",
      "update_user": "Editar um usuário",
      "create_entity": "Criar uma entidade",
      "update_entity": "Editar uma entidade",
      "create_tag": "Criar uma etiqueta",
      "update_tag": "Editar uma etiqueta",
      "create_role": "Criar um papel",
      "update_role": "Editar um papel",
      "create_processApplication": "Criar um processo por aplicação",
      "update_processApplication": "Editar um processo por aplicação",
      "create_process": "Criar um processo por módulo",
      "update_process": "Editar um processo por módulo",
      "create_permission": "Criar uma permissão",
      "update_permission": "Editar uma permissão",
      "create_module": "Criar um módulo",
      "update_module": "Editar um módulo",
      "create_client": "Criar um cliente",
      "update_client": "Editar cliente",
      "create_application": "Criar uma aplicação",
      "update_application": "Editar uma aplicação",
      "create_businessType": "Criar um tipo de negócio",
      "update_businessType": "Editar um tipo de negócio",
      "create_businessUnit": "Criar uma unidade de negócio",
      "update_businessUnit": "Editar uma unidade de negócio",
      "create_country": "Criar um país",
      "update_country": "Editar um país",
      "create_currency": "Criar uma moeda",
      "create_type_responsible": "Criar tipo responsável",
      "update_type_responsible": "Editar tipo responsável",
      "update_currency": "Editar uma moeda",
      "create_documentType": "Criar um tipo de documento",
      "update_documentType": "Editar um tipo de documento",
      "create_product": "Criar um produto",
      "update_product": "Editar um produto",
      "create_workUnit": "Criar uma unidade de trabalho",
      "update_workUnit": "Editar uma unidade de trabalho",
      "create_bank": "Criar Conta Bancária",
      "update_bank": "Atualizar Conta Bancária",
      "create_businessRule": "Criar uma regra de negócio",
      "list_item_to_pay": "Lista de itens a pagar",
      "route_config_import": "Importar rotas",
      "route_config_export": "Exportar rotas",
      "item_selected": "Item selecionados",
      "item_total": "Total de Itens",
      "edit_item_supplier": "Editar item",
      "create_item_supplier": "Criar item fornecedor",
      "update_payment_type": "Editar Tipo de pagamento",
      "create_payment_type": "Criar um Tipo de pagamento",
      "credit_in_favor": "Crédito a favor",
      "general_information": "Informação Geral",
      "update_sale": "Editar venda",
      "update_supplier": "Editar fornecedor",
      "update_reservation": "Editar reserva",
      "update_source": "Editar fonte",
      "general": "Geral",
      "products": "Produtos",
      "add_product": "Adicionar produto",
      "client": "Cliente",
      "passenger": "Passageiros",
      "passengers": "Passageiros",
      "add_passenger": "Adicionar passageiro",
      "update_passenger": "Editar passageiro",
      "aerial": "Aéreo",
      "reserve_information": "Informação da reserva",
      "contanct": "Contato",
      "observations": "Observações",
      "aerial_information": "Informação do voo",
      "segments": "Trechos",
      "segment": "Trecho",
      "add_segment": "Adicionar outro trecho",
      "delete_segment": "Excluir trecho",
      "going": "IDA",
      "return": "VOLTA",
      "departure": "Saída",
      "arrival": "Chegada",
      "scale": "Escala",
      "duration": "Duração",
      "luggage": "Bagagem",
      "wait_in": "Espera no",
      "hotel": "Hotel",
      "car": "Carro",
      "other": "outros",
      "air": "Voo",
      "train": "Trem",
      "flight": "Voo",
      "others": "Outros",
      "other_product": "Produto (Outros)",
      "train_segment": "Segmento de Trem",
      "train_passes": "Passes de Trem",
      "billing": "Faturamento",
      "hotel_information": "Informação do hotel",
      "liquidation": "Liquidação",
      "contact": "Contato",
      "transfer_information": "Informação do traslado",
      "service_information": "Informação do serviço",
      "date": "Datas",
      "direct": "Direto",
      "provider_info": "Dados do fornecedor",
      "tags": "Etiquetas",
      "rooms": "Quartos",
      "people_by_room": "pessoa (s) x1 Quarto.",
      "cancellation_cost": "Custos de cancelamento",
      "cancellation_cost_provider": "Custos de cancelamento do fornecedor",
      "cancellation_cost_client": "Custos de cancelamento do cliente",
      "car_information": "Informação do carro",
      "trip_car_information": "Informação da viagem",
      "train_information": "Informação do trem",
      "customer_file": "Ficha do cliente",
      "client_data": "Dados do Cliente",
      "total_duration": "Duração Total",
      "formula": "Fórmula",
      "edit_businessRule": "Editar Regra",
      "solve_formula": "Fórmula Resolvida",
      "pay_condition": "Condições de pagamento",
      "credits": "Créditos",
      "credit_against": "Saldo a pagar",
      "pending_items": "Itens pendentes",
      "items_to_bill": "Itens a faturar",
      "generated_invoices": "Faturas geradas",
      "actions": "Ações",
      "payment": "Cobrança",
      "transactions": "Transações",
      "pricing": "Detalhamento de preço",
      "liquidation_retail": "Liquidação varejo",
      "liquidation_supplier": "Liquidação fornecedor",
      "liquidation_wholesaler": "Liquidação atacado",
      "transfer": "Traslado",
      "create_cash": "Criar caixa",
      "update_cash": "Editar caixa",
      "contact_emergency": "Contato de emergência",
      "assistance_information": "Informação de assistências",
      "assistance": "Assistências",
      "re_assign": "Reatribuir %{entity}",
      "update_contact": "Atualizar contato",
      "update_liquidation": "Atualizar Liquidação",
      "update_card": "Atualizar cartão",
      "create_card": "Criar cartão",
      "update_pricing": "Editar valores de origem",
      "complementary_item": "Novo item complementar",
      "update_productType": "Editar tipo de produto",
      "create_productType": "Criar tipo de produto",
      "update_variable": "Editar Variável",
      "condition": "Condições",
      "tickets": "Tickets",
      "exchange_type": "Taxa de câmbio",
      "exchange_types": "Taxas de câmbio",
      "recalculate_liquidation_rule": "Qual das seguintes liquidações deseja recalcular?",
      "empty": "Não há %{some}",
      "update_numbering": "Editar numeração",
      "create_numbering": "Criar numeração",
      "create_source": "Criar fonte",
      "last_sales": "Últimas Vendas",
      "air_tickets": "Passagens Aéreas %{name}",
      "select_client_and_app": "Selecione o cliente e a aplicação",
      "sales_with_pending_payment": "Vendas com pagamento pendente",
      "pending_payment": "Pendente pagamento",
      "pending_voucher": "Pendente voucher",
      "autocancel": "Autocancelamento",
      "pending_confirmation": "A confirmar",
      "notification": "Notificações",
      "update_payment_method": "Editar método de pagamento",
      "create_payment_method": "Criar método de pagamento",
      "sales_with_paid_payment": "Vendas com pagamento efetuado",
      "sales_with_guaranteed_payment": "Vendas com pagamento garantido",
      "reservations_to_pay": "Reservas para pagar",
      "see_items": "Ver itens",
      "item_balances": "Saldos de itens",
      "reservation_credit": "Créditos da reserva",
      "send_email": "Enviar email",
      "regenerate_notification": "Gerar nova notificação e enviar email",
      "files": "Arquivos",
      "file": "Arquivo",
      "files_uploaded": "Arquivos enviados",
      "file_name": "Nome do arquivo",
      "create_bannerType": "Criar tipo de banner",
      "update_bannerType": "Editar tipo de banner",
      "create_banner": "Criar banner",
      "update_banner": "Editar banner",
      "create_ext_train_marketing_carrier": "Criar marketing carrier",
      "update_ext_train_marketing_carrier": "Editar marketing carrier",
      "sectors": "Setores",
      "create_landing": "Criar landing",
      "update_landing": "Editar landing",
      "preview_landing": "Pré-visualizar landing",
      "compensation_credit": "Compensação de Crédito",
      "update_transaction": "Editar transação",
      "payment_register": "Registro de Pagamento",
      "addButton": "Adicionar botão",
      "update_eticket": "Editar E-ticket",
      "update_date": "Modificar data",
      "create_due_date_method": "Criar modelo de expiração",
      "update_due_date_method": "Atualizar modelo de expiração",
      "create_due_date_range": "Criar intervalo de datas de vencimento",
      "update_due_date_range": "Atualizar intervalo de datas de vencimento",
      "update_pricing_passenger": "Atualizar valores de origem do passageiro %{passenger}",
      "update_exchange_type": "Editar Tipo de Câmbio",
      "product_value_assignment": "Atribuição de valores de Produto",
      "update_financial_entity": "Atualizar Entidade Financeira",
      "create_custom_var": "Criar Variável Personalizada",
      "select_exist_label": "Selecionar uma Etiqueta Existente",
      "select_work_unit": "Selecione uma unidade de trabalho",
      "create_company": "Criar Companhia",
      "update_company": "Atualizar Companhia",
      "create_financial_entity": "Atualizar Entidade Financeira",
      "update_operation_type": "Atualizar Tipo de operação",
      "create_operation_type": "Criar Tipo de operação",
      "update_due_date": "Atualizar data de vencimento do pagamento",
      "my_devices": "Meus dispositivos",
      "credits_applied": "Créditos aplicados",
      "credit_applied_detail": "Destino do crédito",
      "payment_info": "Informações de pagamento",
      "paymentRecord": "Registro de Pagamento",
      "reservationsToPaySelection": "Seleção de reservas a pagar",
      "reservationSelection": "Seleção de reservas",
      "selectedReservations": "Selected reservations",
      "selectReservations": "Selecionar reservas",
      "reservationItems": "Itens da reserva",
      "requestConfirmation": "Confirmação de solicitação",
      "totals": "Totales",
      "applicant": "Solicitante",
      "paymentDetails": "Dados do pagamento",
      "exchangeRateHistory": "Histórico de taxas de câmbio",
      "labelReceiptAndImputation": "Recibo e imputação",
      "history": "Histórico",
      "trip_info": "Informações da viagem",
      "fraud_info": "Informações de fraude",
      "customer_data": "Dados do cliente",
      "create_commerce_number": "Criar Número de Comércio",
      "update_commerce_number": "Atualizar Número de Comércio",
      "create_gateway": "Criar Gateway de Pagamento",
      "update_gateway": "Atualizar Gateway de Pagamento",
      "move_credit_reservation": "Mover creditos",
      "payment_order_requirement": "Requerimiento de orden de pago",
      "create_installment": "Criar financiamento",
      "update_installment": "Editar financiamento",
      "import_installment": "Indique a forma de financiamento que deseja importar",
      "operations_required_action": "Mesa Operacional - Ação Necessária",
      "emited_without_fee": "Emitido sem taxa",
      "failed_emit": "Falha na transmissão",
      "pending_payment_cash": "Pagamentos pendentes - Dinheiro",
      "pending_billing": "Faturamento pendente",
      "transactions_resume": "(Data de hoje) Resumo da transação",
      "in_site": "No local",
      "reserved": "Reservado",
      "cancelled": "Cancelado",
      "error": "Erro",
      "issued": "Emitido",
      "share_by_status": "Compartilhar por estado",
      "share_by_cancelation_type": "Compartilhar por tipo de cancelamento",
      "cancelled_by_fraud": "Cancelado devido a fraude",
      "cancelled_by_failed_payment": "Cancelado devido a falha no pagamento",
      "cancelled_by_failed_booking": "Cancelado devido a falha na reserva",
      "cancelled_by_payment_cash": "Pagamento em dinheiro cancelado",
      "cancelled_by_expired_session": "Cancelado devido a sessão expirada",
      "general_conditions": "condições gerais",
      "fee_conditions": "Condições de tarifa",
      "user_agent": "Agente de usuário",
      "last_login": "Último login",
      "suppliers_actions": "Ações fornecedores",
      "reserve_requirement": "Requisitos da reserva",
      "clients_actions": "Ações de clientes",
      "price_history": "Histórico de preços",
      "origin_values": "Valores de origem",
      "returns": "Devoluções",
      "code_edit": "Editar códigos",
      "update_status": "Alterar status",
      "balances": "Saldos",
      "how_much_to_pay": "Quanto tenho em atraso e preciso pagar hoje?",
      "weekly_due_dates": "Vencimentos semanais",
      "debt_per_period": "Dívida por período",
      "detail_per_reservation": "Detalhes por reserva",
      "last_payments": "Últimos pagamentos",
      "whith_balances": "Saldo devedor",
      "with_credits": "Saldo credor",
      "balance_to_pay": "Saldo a pagar",
      "edit_report": "Editar relatório",
      "scheduled_reports": "Relatórios agendados",
      "generated_reports": "Relatórios gerados",
      "credits_data": "Dados do crédito",
      "noDataAvailable": "Nenhum dado disponível",
      "billing_number": "Insira o número do item para faturamento:",
      "balance_transfer_received": "Transferências de Saldo Recebidas",
      "balance_transfer_sent": "Transferências de Saldo Enviadas",
      "confirm_action": "Confirmar ação",
      "generate_business_items": "Gerar Negócio + Itens",
      "clients": "CLIENTES",
      "suppliers": "Fornecedores",
      "supplier": "Fornecedor",
      "registers": "Registros",
      "register": "Registro",
      "edit_config": "Editar configuração",
      "user_information": "Informações do usuário",
      "create_ext-air-airline": "Criar companhia aérea",
      "update_ext-air-airline": "Editar companhia aérea",
      "commercial_documents": "Documentos comerciais",
      "items": "Items",
      "services": "Serviços",
      "color_reference": "Referência de cor",
      "document_data": "Detalhes do documento",
      "create_billing": "Criar fatura",
      "update_billing": "Editar fatura",
      "voucher_details": "Dados do comprovante",
      "invoice_already_exists": "O item que você inseriu já existe em uma fatura",
      "delete_file": "Excluir anexo",
      "create_supplier": "Criar fornecedor",
      "basic_data": "Informações básicas",
      "fiscal_data": "Detalhes fiscais",
      "configuration": "Configuração",
      "create_base": "Criar base",
      "update_base": "Editar base",
      "create_supplier_conciliation": "Nova conciliação",
      "supplier_conciliation_detail": "Detalhes da conciliação",
      "supplier_conciliation": "Conciliação",
      "supplier-conciliation": "Conciliação",
      "preview": "Pré-visualização",
      "promotions": "Promoções",
      "flexi": "Flexi",
      "flexiRate": "Taxa Flexível",
      "servicePackage": "Pacote premium",
      "extra_baggage": "Excesso de bagagem",
      "coupon_data": "DADOS DO CUPOM",
      "discount_type_amount": "TIPO E VALOR DO DESCONTO",
      "create_promotion": "Criar promoção",
      "update_promotion": "Editar promoção",
      "pending_hepstar": "Hepstar Pendentes"
    },
    "notification": {
      "noRoleApplication": "Nenhum papel encontrado para a aplicação selecionada",
      "noPermissionApplication": "Nenhuma permissão encontrada para a aplicação selecionada",
      "noApplicationClient": "Nenhuma aplicação encontrada para o cliente selecionado",
      "clientsNotFound": "Nenhum cliente encontrado",
      "updated": "Elemento atualizado |||| %{smart_count} elementos atualizados",
      "created": "Elemento criado",
      "deleted": "Elemento excluído |||| %{smart_count} elementos excluídos",
      "bad_item": "Elemento incorreto",
      "item_doesnt_exist": "O elemento não existe",
      "http_error": "Erro de comunicação com o servidor",
      "currency_or_supplier_missing": "Parâmetros de moeda ou fornecedor ausentes",
      "due_date_required": "A data de vencimento é obrigatória",
      "no_supplier_items_to_generate_invoice": "Nenhum item do fornecedor encontrado para gerar a fatura",
      "canceled": "Ação cancelada",
      "error_updated": "Desculpe, não conseguimos atualizar o Elemento %{smart_count}",
      "data_provider_error": "Desculpe, houve um problema com o provedor de dados",
      "no_static_json": "Nenhum JSON padrão encontrado",
      "created_success_masculine": "O %{element} foi criado corretamente",
      "created_success_femenine": "A %{element} foi criada corretamente",
      "created_error_masculine": "O %{element} não foi criado",
      "created_error_femenine": "A %{element} não foi criada",
      "create_invoice_process_error_in_conciliation": "Ocorreu um erro durante o processo. Verifique manualmente a criação da fatura",
      "updated_success_masculine": "O %{element} foi atualizado corretamente",
      "updated_success_femenine": "A %{element} foi atualizada corretamente",
      "updated_error_masculine": "O %{element} não foi atualizado",
      "updated_error_femenine": "A %{element} não foi atualizada",
      "deleted_success_masculine": "O %{element} foi excluído corretamente",
      "deleted_success_femenine": "A %{element} foi excluída corretamente",
      "deleted_error_masculine": "O %{element} não foi excluído",
      "deleted_error_femenine": "A %{element} não foi excluída",
      "authorized_success": "Ordem de pagamento autorizada com sucesso",
      "unauthorized_success": "Ordem de pagamento desautorizada com sucesso",
      "retry_supplier_billing_success": "O reenvio da fatura do fornecedor foi realizado com sucesso",
      "retry_supplier_billing_error": "Não foi possível reenviar a fatura do fornecedor",
      "canceled_item_reserve_success": "A Reserva %{reserve} foi cancelada",
      "cancellation_in_progress": "A reserva %{reserve} será cancelada o mais breve possível",
      "canceled_item_reserve_error": "A Reserva %{reserve} NÃO foi cancelada",
      "delete_item_error": "O item %{item} NÃO foi excluído",
      "delete_item_success": "O item %{item} foi excluído",
      "emit_status_item_success": "O item %{item} foi emitido",
      "emit_status_item_error": "O item %{item} NÃO foi emitido",
      "cancel_status_item_success": "O item %{item} foi cancelado",
      "cancel_status_item_error": "O item %{item} NÃO foi cancelado",
      "guarantee_item_success": "O item %{item} foi garantido",
      "guarantee_item_error": "O item %{item} NÃO foi garantido",
      "move_item_success": "O item %{item} foi movido",
      "move_item_error": "O item %{item} NÃO foi movido",
      "complementary_item_success": "Item complementar criado com sucesso",
      "complementary_item_error": "Erro ao criar item complementar",
      "emit_item_reserve_success": "A emissão da reserva %{reserve} foi solicitada",
      "emit_item_reserve_error": "A emissão da reserva %{reserve} NÃO foi solicitada %{reason}",
      "emit_item_fail_reserve_error": "Houve um erro, A reserva %{reserve} NÃO foi emitida",
      "retrive_item_reserve_success": "A reserva %{reserve} foi atualizada",
      "retrive_item_reserve_error": "Houve um erro, A reserva %{reserve} NÃO foi atualizada",
      "refund_segment_item_reserve_success": "O segmento %{segment} foi reembolsado",
      "refund_segment_item_reserve_error": "O segmento %{segment} NÃO foi reembolsado",
      "delete_segment_item_reserve_success": "O segmento %{segment} foi excluído",
      "delete_segment_item_reserve_error": "O segmento %{segment} NÃO foi excluído",
      "updated_success_passenger": "O passageiro %{passenger} foi atualizado corretamente",
      "updated_success_titular": "O passageiro %{passenger} agora é titular",
      "updated_error_titular": "O passageiro %{passenger} não pôde ser atualizado",
      "updated_success_business_unit": "O cliente foi atualizado para %{client}",
      "updated_error_business_unit": "Não foi possível atualizar o cliente",
      "add_success_passenger": "O passageiro %{passenger} foi adicionado corretamente",
      "add_error_passenger": "Não foi possível adicionar o passageiro",
      "success_full_process": "O processo completo foi concluído com sucesso",
      "error_full_process": "O processo completo não foi concluído",
      "created_success_sale_reservation": "Negócio gerado corretamente",
      "created_error_sale_reservation": "Não foi possível gerar o negócio",
      "deleted_success_sale_reservation": "Negócio excluído corretamente",
      "deleted_error_sale_reservation": "Não foi possível excluir o negócio",
      "deleted_success_invoice_reservation": "Fatura excluída corretamente",
      "deleted_error_invoice_reservation": "Não foi possível excluir a fatura",
      "created_success_add_items_reservation": "Itens adicionados corretamente",
      "created_error_add_items_reservation": "Não foi possível adicionar os itens",
      "updated_error_items_success": "Os itens foram atualizados corretamente",
      "updated_error_items_error": "Os itens NÃO foram atualizados",
      "updated_success_contact": "O Contato %{contact} foi atualizado",
      "add_tag_success": "A etiqueta foi adicionada",
      "add_tag_error": "A etiqueta NÃO foi adicionada",
      "remove_tag_error": "Houve um problema ao excluir a etiqueta",
      "updated_error_contact": "O Contato não pôde ser atualizado",
      "updated_success_pricing": "O preço foi atualizado",
      "updated_error_pricing": "O preço não pôde ser atualizado",
      "updated_success_seller": "O Vendedor foi atualizado",
      "updated_error_seller": "Não foi possível atualizar o Vendedor",
      "updated_success_liquidation": "A liquidação foi atualizada",
      "updated_error_liquidation": "A liquidação não pôde ser atualizada",
      "liquidation_rule_invalid": "As variáveis estão ocultas ou a regra foi mal carregada",
      "check_extra_cost": "Por favor, verifique se todos os custos extras foram calculados",
      "error_retrieve": "Houve um erro ao recuperar os dados do fornecedor",
      "error_loading_products": "Houve um erro ao carregar os produtos",
      "change_password_success": "A senha foi alterada com sucesso",
      "change_password_error": "A senha NÃO foi alterada",
      "forward_email_to_success": "O email foi enviado para %{email_to}",
      "forward_email_to_error": "Ocorreu um erro ao enviar o Email, por favor tente mais tarde",
      "regenerate_notification_to_success": "A notificação foi gerada corretamente",
      "regenerate_notification_to_error": "Ocorreu um erro ao gerar a notificação, por favor tente mais tarde",
      "create_error_banner_by_work_unit": "Não foi possível adicionar os banners à unidade de trabalho",
      "create_error_banner_by_business_unit": "Não foi possível adicionar os banners à unidade de negócio",
      "update_error_banner_by_work_unit": "Não foi possível atualizar os banners da unidade de trabalho",
      "update_error_banner_by_business_unit": "Não foi possível atualizar os banners da unidade de negócio",
      "upload_image_error": "Ocorreu um erro ao fazer upload da imagem",
      "clone_item_success": "O item %{item} foi clonado",
      "clone_item_error": "O item %{item} NÃO foi clonado",
      "aftersales_item_success": "A pós-venda do item %{item} foi criada",
      "aftersales_item_error": "A pós-venda do item %{item} NÃO foi criada",
      "error_update_view": "Houve um erro ao tentar atualizar a visualização.",
      "already_update_view": "A visualização foi atualizada recentemente, por favor, tente novamente mais tarde.",
      "success_update_view": "A visualização foi atualizada.",
      "applied_credit_success": "Crédito aplicado com sucesso!",
      "applied_credit_error": "Houve um erro ao aplicar o crédito",
      "update_transaction_success": "A transação foi atualizada com sucesso!",
      "update_transaction_error": "Houve um erro ao atualizar a transação",
      "currency_not_found_in_business_unit": "A moeda %{currency} não existe na lista de moedas da unidade de negócio",
      "currency_exchange_not_found": "não existe taxa de câmbio da %{currency}.",
      "pnr_used": "O PNR já foi importado ou não existe",
      "splited_item_reserve_error": "Houve um erro ao tentar separar os/o passageiros/passageiro",
      "splited_item_reserve_success": "Separação bem-sucedida!",
      "void_item_reserve_success": "A reserva %{reserve} foi anulada com sucesso!",
      "void_item_reserve_error": "Houve um erro ao tentar anular a reserva %{reserve}",
      "due_date_success": "A data foi atualizada com sucesso!",
      "due_date_error": "Houve um erro ao tentar atualizar a data.",
      "update_error_date_range": "Houve um erro ao tentar atualizar o intervalo de datas.",
      "create_error_date_range": "Houve um erro ao tentar criar o intervalo de datas.",
      "delete_error_date_range": "Houve um erro ao tentar excluir o intervalo de datas.",
      "delete_success_date_range": "O intervalo de datas foi excluído com sucesso!",
      "delete_error_due_date_method": "Ocorreu um erro ao tentar excluir o modelo de data de vencimento",
      "delete_success_due_date_method": "O modelo de data de vencimento foi excluído com sucesso!",
      "approve_fraud_item_reserve_success": "Análise de fraude aprovada com sucesso",
      "approve_fraud_item_reserve_error": "A análise de fraude não pôde ser aprovada",
      "refuse_fraud_item_reserve_success": "A análise de fraude foi rejeitada com sucesso",
      "refuse_fraud_item_reserve_error": "A análise de fraude não pôde ser rejeitada",
      "relationshipDeletedSuccess": "Relação excluída com sucesso",
      "errorDeletingRelationship": "Erro ao excluir a relação",
      "transfer_credit_success": "Os créditos foram transferidos com sucesso!",
      "transfer_credit_error": "Ocorreu um erro ao transferir créditos",
      "no_gateway_options": "Não há opção de gateway ativada",
      "generate_order_success": "A ordem de pagamento foi gerada corretamente",
      "generate_order_error": "Ocorreu um erro ao gerar a ordem de pagamento",
      "unapply_payment_success": "Pagamento cancelado com sucesso.",
      "unapply_payment_error": "Não foi possível cancelar o pagamento.",
      "register_return_success": "O item %{item} foi devolvido.",
      "register_return_error": "O item %{item} não foi devolvido.",
      "add_notification": "%{user} adicionei a notificação",
      "edit_codes_error": "Os códigos não puderam ser atualizados",
      "report_deleted_success": "O relatório foi excluído com sucesso",
      "report_deleted_error": "Ocorreu um erro ao excluir o relatório",
      "credit_updated_success": "Crédito atualizado com sucesso",
      "credit_updated_error": "Crédito não atualizado",
      "delete_error_items_success": "Os itens foram eliminados corretamente",
      "delete_error_items_error": "Os itens NÃO foram eliminados",
      "disable_rebooker_success": "Rebooker desativado corretamente",
      "disable_rebooker_error": "Ocorreu um erro ao desativar o rebooker",
      "send_question_error": "Ocorreu um erro ao enviar a pergunta",
      "apply_credits_success": "Os créditos foram aplicados com sucesso",
      "apply_credits_error": "Ocorreu um erro ao aplicar os créditos",
      "edit_business_number_success": "Número de negócio editado corretamente",
      "edit_business_number_error": "Ocorreu um erro ao editar o número de negócio",
      "updated_notifications_success": "As notificações foram atualizadas com sucesso",
      "updated_notifications_error": "Ocorreu um erro ao atualizar as notificações",
      "max_chars_prompt": "Sua pergunta não pode exceder 1000 caracteres de comprimento",
      "invoice_generated_success": "A fatura foi criada com sucesso",
      "invoice_generated_error": "Ocorreu um erro ao criar a fatura",
      "journal_entry_generated_success": "O lançamento contábil foi criada com sucesso",
      "journal_entry_generated_error": "Ocorreu um erro ao criar o lançamento contábil",
      "provision_generated_success": "A provisão foi criada com sucesso",
      "provision_generated_error": "Ocorreu um erro ao criar a provisão",
      "invalidate_provision_success": "A provisão foi anulada com sucesso",
      "invalidate_provision_error": "Ocorreu um erro ao anular a provisão",
      "order_generated_success": "A orden de pagamento foi criada com sucesso",
      "order_generated_error": "Ocorreu um erro ao criar a orden de pagamento ",
      "delete_paymente_success": "Pagamentos excluídos com sucesso",
      "delete_paymente_error": "Houve um problema ao excluir os pagamentos",
      "wait_data_loading": "Por favor, aguarde até que todos os dados sejam carregados",
      "error_loading_work_units": "Erro: Não foi possível carregar as unidades de trabalho",
      "error_loading_destination_types": "Erro: Não foi possível carregar os tipos de destino",
      "error_loading_currencies": "Erro: Não foi possível carregar as moedas",
      "error_select_work_unit": "Erro: Você deve selecionar uma unidade de trabalho",
      "error_currency_not_available": "Erro: A moeda selecionada não está disponível",
      "error_work_units_not_available": "Erro: Os dados das unidades de trabalho não estão disponíveis",
      "error_currencies_not_available": "Erro: Os dados das moedas não estão disponíveis",
      "error_work_unit_id_not_found": "Erro: Não foi possível obter o ID da unidade de trabalho selecionada. Por favor, selecione novamente a unidade de trabalho.",
      "error_currency_id_not_found": "Erro: Não foi possível obter o ID da moeda selecionada. Por favor, selecione novamente a moeda.",
      "mirror_edit_success": "Mirror editado com sucesso",
      "mirror_edit_error": "Ocorreu um erro ao editar o mirror",
      "formula_copy_success": "Fórmula copiada com sucesso",
      "formula_copy_error": "Houve um erro ao copiar a fórmula",
      "formula_paste_success": "Fórmula colada com sucesso",
      "formula_paste_error": "Houve um erro ao colar a fórmula",
      "edit_extract_success": "Extrato bancário editado com sucesso",
      "edit_extract_error": "Ocorreu um erro ao editar o extrato bancário",
      "edit_receipt_success": "Recibo editado com sucesso",
      "edit_receipt_error": "Ocorreu um erro ao editar o recibo",
      "update_receipt_success": "Recibo atualizado com sucesso",
      "update_receipt_error": "Ocorreu um erro ao atualizar o recibo",
      "different_bases_error": "As bases das reservas selecionadas não coincidem",
      "voucher_not_found": "Não existe configuração de voucher associada a este produto",
      "voucher_error": "Erro ao gerar voucher para este item",
      "delete_condition_success": "A condição foi excluída com sucesso",
      "delete_condition_error": "Ocorreu um erro ao excluir a condição",
      "after_sales_item_success": "O item de pós-venda foi criado com sucesso",
      "after_sales_item_error": "Não foi possível criar o item de pós-venda",
      "edit_variables_success": "Variáveis editadas corretamente",
      "edit_variables_error": "Ocorreu um erro ao editar as variáveis",
      "edit_item_supplier_success": "O item foi editado corretamente",
      "edit_item_supplier_error": "Ocorreu um erro ao editar o item",
      "create_item_supplier_success": "O item fornecedor foi criado corretamente",
      "create_item_supplier_error": "Ocorreu um erro ao criar o item fornecedor",
      "delete_extract_success": "A movimentação bancária foi excluída com sucesso",
      "delete_extract_error": "Houve um erro ao excluir a movimentação bancária",
      "inactive_business_unit": "A Unidade de Negócio foi desativada porque não foi possível excluí-la",
      "generate_credite_note_success": "Nota de crédito gerada com sucesso",
      "generate_credite_note_error": "Não foi possível gerar a nota de crédito",
      "invalidate_document_success": "Documento cancelado com sucesso",
      "invalidate_document_error": "Ocorreu um erro ao cancelar o documento",
      "refetch_data_error": "Ocorreu um erro ao atualizar o documento",
      "visualize_invoice_error": "Houve um erro ao visualizar os dados",
      "upload_file_error": "Ocorreu um erro ao carregar o arquivo",
      "conciliation_process_started": "Arquivo de conciliação recebido e processamento iniciado (ID: %{id})",
      "conciliation_process_error": "Erro ao iniciar o processamento da conciliação",
      "export_conciliation_items_scheduled": "O relatório está sendo processado. Você receberá um e-mail.",
      "please_select_field": "Por favor selecione %{field}",
      "delete_file_success": "O arquivo foi excluído com sucesso",
      "delete_file_error": "Erro ao excluir o arquivo"
    },
    "validation": {
      "required": "Obrigatório",
      "minLength": "Deve ter pelo menos %{min} caracteres",
      "maxLength": "Deve ter %{max} caracteres ou menos",
      "minValue": "Valor deve ser maior que %{min}",
      "maxValue": "Valor deve ser menor que %{max}",
      "number": "Deve ser um número",
      "email": "Deve inserir um e-mail válido",
      "oneOf": "Deve ser um dos seguintes valores: %{options}",
      "regex": "Deve seguir um formato específico (regexp): %{pattern}",
      "date_invalid": "Por favor, insira uma data válida",
      "date_min": "Por favor, insira uma data maior",
      "date_max": "Por favor, insira uma data menor",
      "noOptionsText": "Não há opções",
      "minCharacters": "Digite pelo menos dois caracteres para buscar",
      "time_invalid": "Por favor, insira um horário válido",
      "maxCharacters": "Você excedeu o máximo de caracteres, deve ser menos de %{characters}",
      "fieldIsRequired": "Este campo é obrigatório",
      "errorCreatingBases": "Parece que ocorreu um erro ao criar as bases. Por favor, verifique se todos os campos estão preenchidos.",
      "errorCreatingBasesValues": "Parece que ocorreu um erro ao criar as bases. Os valores das relações devem ser maiores que 0.",
      "errorCreatingBasesUniqueCombinations": "Parece que ocorreu um erro ao criar as bases. As combinações de moeda de origem, moeda de destino e base devem ser únicas.",
      "missingFields": "Faltam preencher campos obrigatórios",
      "noSpaces": "Espaços não são permitidos"
    },
    "tooltiptext": {
      "rule_type_first": "Deve selecionar o tipo de regra primeiro"
    },
    "modules": {
      "authentication": "Autenticação",
      "administration": "Administração",
      "marketing": "Gestão de Conteúdos",
      "sales": "Vendas",
      "payment": "Pagamentos",
      "setup": "Configuração",
      "rules": "Regras",
      "purchases": "Compras",
      "billing": "Compras"
    },
    "single_entity": {
      "application": "aplicação",
      "client": "cliente",
      "module": "módulo",
      "permission": "permissão",
      "process": "processo por módulo",
      "processApplication": "processo por aplicação",
      "role": "papel",
      "user": "usuário",
      "business-type": "tipo de negócio",
      "business-unit": "unidade de negócio",
      "country": "país",
      "currency": "moeda",
      "document-type": "tipo de documento",
      "product-type": "tipo de produto",
      "product": "produto",
      "work-unit": "unidade de trabalho",
      "business-rule": "regra de negócio",
      "entity": "entidade",
      "payment-entity": "cobrança",
      "installment": "financiamento",
      "card": "cartão",
      "source": "fonte",
      "bank": "banco",
      "expenses": "despesa",
      "operation-type": "tipo de operação",
      "cash": "caixa",
      "company": "companhia",
      "financial-entity": "entidade financeira",
      "type-responsible": "tipo responsável",
      "payment-type": "tipo de pagamento",
      "payment-method": "método de pagamento",
      "type_responsible": "tipo de responsável",
      "reservation": "reserva",
      "supplier": "fornecedor",
      "tag": "etiqueta",
      "banner-type": "tipo de banner",
      "banner": "banner",
      "ext-train-marketing-carrier": "marketing carrier",
      "landing": "landing",
      "formula-global-variables": "Variável global da fórmula",
      "due-date-method": "Modelo de expiração",
      "date-range": "Cronograma de Expiração",
      "due-date-range": "Intervalo de Data de Vencimento",
      "gateway": "Gateway de Pagamento",
      "commerce-number": "Número de Comércio",
      "operation": "operação",
      "route-config": "configuração de rota",
      "supplier-billing": "fatura",
      "supplier-payment-order": "orden de pagamento",
      "promotion": "promoção",
      "operation-bff": "Operação BFF",
      "ext-air-airline": "Companhias aérea",
      "supplier-conciliation": "conciliação",
      "bases": "bases",
      "base": "Base"
    },
    "entity": {
      "bilingform_conciliation": "Conciliações",
      "bilingform_extracts": "Extratos",
      "billingform": "Formulário de pagamento",
      "child_entities": "Filhos",
      "sales": "Vendas",
      "otherModule": "Outro módulo",
      "config_application": "Configuração de aplicações",
      "work-unit": "Unidade de Trabalho",
      "business-unit": "Unidade de Negócio",
      "currency": "Moeda",
      "document-type": "Tipo de documento",
      "product-type": "Tipo de produto",
      "country": "País",
      "product": "Produto",
      "business-type": "Tipo de negócio",
      "reservation": "Reserva",
      "air-detail": "Detalhe Aéreo",
      "hotel-detail": "Detalhe de Hotéis",
      "user": "Usuário",
      "role": "Papel",
      "permission": "Permissões",
      "client": "Cliente",
      "application": "Aplicação",
      "process": "Processos por Módulo",
      "processApplication": "Processos por Aplicação",
      "module": "Módulo",
      "userByClientApp": "Usuário da aplicação-cliente",
      "permissionByUser": "Permissões do usuário",
      "applicationByClient": "Aplicação do cliente",
      "permissionByRole": "Permissões do papel",
      "item": "Item",
      "supplier": "Fornecedor",
      "contact": "Contato",
      "roleByUser": "Papel do usuário",
      "user-by-business-unit": "Usuário por Unidade de Negócio",
      "product-work-unit-by-business-unit": "Produto da Unidade de trabalho por Unidade de negócio",
      "car-detail": "Detalhe do carro",
      "user-by-work-unit": "Usuário por Unidade de Trabalho",
      "currency-by-business-unit": "Moeda por Unidade de Negócio",
      "currency-by-work-unit": "Moeda por Unidade de Trabalho",
      "pax": "Passageiro",
      "fiscal-data": "Informação fiscal",
      "cancel-info": "Informação de cancelamento",
      "cancel-info-item": "Informação de cancelamento da reserva",
      "product-by-work-unit": "Produto por Unidade de Trabalho",
      "pax-item": "Passageiro da reserva",
      "billing": "Faturamento",
      "business-rule": "Regras de negócio",
      "entity": "Entidade",
      "installment": "Financiamento",
      "card": "Cartões",
      "source": "Fonte",
      "bank": "Banco",
      "payment-type": "Tipo de pagamento",
      "payment-method": "Método de pagamento Cartão",
      "expenses": "Despesas",
      "operation-type": "Tipo de operação",
      "cash": "Caixa",
      "company": "Companhia",
      "financial-entity": "Entidade Financeira",
      "versions": "Versões",
      "type-responsible": "Tipo Responsável",
      "numbering": "Numeração",
      "payment-entity": "Pagamentos",
      "tag": "Etiqueta",
      "banner-type": "Tipo Banner",
      "banner": "Banner",
      "ext-train-marketing-carrier": "Marketing Carrier",
      "landing": "Landing",
      "userB2": "Usuário",
      "formula-global-variables": "Variáveis globais de fórmulas",
      "due-date-method": "Modelo de expiração",
      "due-date-range": "Pagamento devido",
      "financial_entity": "Entidade financeira",
      "my-devices": "Meus dispositivos",
      "operation": "Operações",
      "commerce-number": "Nº de Comércio",
      "gateway": "Gateway de Pagamento",
      "notification": "Notificações",
      "account-state": "Extrato da conta",
      "reporting": "Relatórios",
      "route-config": "Rotas",
      "supplier-billing": "Faturas",
      "supplier-payment-order": "Ordens de pagamento",
      "operation-bff": "Operações BFF",
      "promotion": "Promoções",
      "item-supplier": "Extrato de conta de fornecedores",
      "devices-by-user": "Dispositivos por usuário",
      "account-transfer": "Transferência de conta",
      "baggage-options": "Opções de bagagem",
      "promotion-coupon": "Cupom promocional",
      "supplier-billing-item": "Item de faturamento do fornecedor",
      "supplier-payment-order-item": "Item de ordem de pagamento ao fornecedor",
      "payment-order-detail": "Detalhe da ordem de pagamento",
      "payment-cash": "Pagamento em dinheiro",
      "payment-online": "Pagamento online",
      "userPaym": "Pagamento do usuário",
      "work-unitPaym": "Pagamento da unidade de trabalho",
      "cash-detail": "Detalhe do pagamento em dinheiro",
      "payment-method-by-work-unit": "Método de pagamento por unidade de trabalho",
      "payment-type-by-work-unit": "Tipo de pagamento por unidade de trabalho",
      "article": "Artigo",
      "clientBilling": "Faturamento do cliente",
      "itemBilling": "Faturamento do item",
      "voucher": "Voucher",
      "air-rule-detail": "Detalhe da regra aérea",
      "car-rule-detail": "Detalhe da regra de carro",
      "destination-type": "Tipo de destino",
      "hotel-rule-detail": "Detalhe da regra de hotel",
      "item-rule": "Regra do item",
      "payment-detail": "Detalhe do pagamento",
      "rule-type": "Tipo de regra",
      "static-json": "JSON estático",
      "other-detail": "Outro detalhe",
      "air_tickets": "Passagens aéreas",
      "air-import": "Importar Aéreos",
      "sourcePayment": "Fonte de Financiamento",
      "ext-air-airline": "Companhias aéreas",
      "invoice": "Faturamento",
      "supplier-conciliation": "Conciliação",
      "bases": "base",
      "product-payment-by-work-unit": "Pagamento de produto por unidade de trabalho",
      "business-unit-due-date-by-product": "Vencimento de unidade de negócio por produto",
      "product-payment-by-business-unit": "Pagamento de produto por unidade de negócio",
      "date-range": "Intervalo de datas",
      "work-unit-due-date-by-product": "Vencimiento de unidade de trabalho por produto"
    },
    "field": {
      "departure": "Partida",
      "arrival": "Chegada",
      "segment": "Trecho",
      "first_name": "Nome",
      "last_name": "Sobrenome",
      "date_of_birth": "Data de Nascimento",
      "doc_type": "Tipo de Documento",
      "doc_number": "Número do Documento",
      "country_of_residence": "País de Residência",
      "email_address": "Endereço de Email",
      "extract_file": "Extrair arquivo",
      "include_deleted": "Incluir excluídos",
      "total_records": "Total de registros",
      "reconciled": "Conciliado",
      "not_found": "Não encontrados",
      "with_differences": "Com diferenças",
      "date_from": "Data de",
      "date_to": "Data até",
      "xls_file": "Arquivo XLS",
      "required_columns_info": "Colunas necessárias: LOCALIZADOR, VALOR",
      "xls_xlsx_file": "Arquivo XLS/XLSX",
      "drag_file_here": "Arraste o arquivo aqui ou",
      "select_file_button": "Selecionar arquivo",
      "file_format_info": "Apenas .xls ou .xlsx · Máx. 10 MB",
      "supplier_value": "Valor Fornecedor",
      "b2_value": "Valor B2",
      "difference_value": "Diferença",
      "difference": "Diferença",
      "conciliation_air": "Aéreo",
      "conciliation_land": "Terrestre",
      "has_invoice": "Possui fatura",
      "is_paid": "Está pago",
      "short_reservation_number": "Nro. reserva",
      "ut": "UT",
      "seller": "Vendedor",
      "actions": "Ações",
      "status": "Status",
      "status_b2": "Status B2",
      "invoiced": "Emitido",
      "code": "Código",
      "date": "Data",
      "currency": "Moeda",
      "locator": "Localizador",
      "supplier": "Fornecedor",
      "total_reconciled": "Total conciliado",
      "general_status": "Status",
      "aftersales_destination": "Destino pós-venda",
      "same_reservation": "Mesma reserva",
      "new_reservation": "Nova reserva",
      "adjustment_type": "Ajuste",
      "cost_only": "Apenas custo",
      "cost_and_sale": "Custo e venda",
      "clickable_stats_help": "↑ Cada valor é clicável e filtra a tabela",
      "showing_all": "Exibindo: todos os registros",
      "showing_reconciled": "Exibindo: linhas conciliadas",
      "showing_not_found": "Exibindo: linhas não encontradas",
      "showing_differences": "Exibindo: linhas com diferenças · ordenadas do maior para o menor",
      "showing_unreconciled": "Exibindo: linhas não conciliadas",
      "unreconciled": "Não conciliados",
      "no_records": "Nenhum registro para exibir",
      "rows_per_page": "Linhas por página",
      "states_legend": "Status:",
      "actions_legend": "Ações:",
      "reconciled_legend": "Conciliado (automático)",
      "reconciled_adjusted_legend": "Conciliado por ajuste",
      "reconciled_manually_legend": "Conciliado manualmente",
      "reconciled_duplicate_legend": "Conciliado previamente",
      "difference_legend": "Com diferença",
      "not_found_legend": "Não encontrado",
      "unreconciled_legend": "Não conciliado",
      "deleted_legend": "Excluído",
      "total_deleted": "Excluídos",
      "op_generated_from_conciliation": "Ordem de pagamento gerada a partir da Conciliação #%{id}",
      "generate_op_success": "Ordem de pagamento gerada corretamente",
      "auto_adjustment_legend": "Ajuste automático",
      "cost_sale_adjustment_legend": "Ajuste custo/venda",
      "delete_line_legend": "Excluir linha",
      "confirm_unreconcile_title": "Confirmar Não conciliado",
      "confirm_unreconcile_msg": "Tem certeza de que deseja marcar este item como \"Não conciliado\"?",
      "confirm_delete_title": "Confirmar exclusão",
      "confirm_delete_msg": "Tem certeza de que deseja excluir esta linha da conciliação?",
      "confirm_retry_title": "Confirmar nova tentativa de conciliação",
      "confirm_retry_msg": "Tem certeza de que deseja tentar novamente a conciliação dos itens selecionados? (%{count})",
      "confirm_retry_all_msg": "Tem certeza de que deseja tentar novamente a conciliação de todos os itens? (%{count})",
      "retry_scheduled_success": "Processo de nova tentativa de conciliação agendado em segundo plano",
      "aftersales_success": "Ação pós-venda gerada com sucesso",
      "reservations": "reservas",
      "retentions": "retenções",
      "certificate": "Certificado",
      "payers_document_number": "Número de documento pago",
      "coupon_number": "Número do cupom",
      "download_receipts": "Baixar recibos",
      "download_extract": "Baixar extrato",
      "observations": "Observações",
      "observations_internal": "Observações internas",
      "inputation_type": "Tipo de alocação",
      "amount_aboned": "Monto abonado",
      "select_all": "todos...",
      "created_until": "Data até",
      "created_from": "Data desde",
      "undefined": "indefinido",
      "include": "Incluir",
      "exclude": "Excluir",
      "choices": "Opções",
      "total_reservation": "Reserva total",
      "chosen": "Escolhidos",
      "selected": "selecionados",
      "status_flow": "Status do fluxo",
      "pass_name": "Produto",
      "pass_validity": "Validade",
      "pass_duration": "Duração",
      "pass_offer_type": "Tipo de Oferta",
      "pass_marketing_carrier": "Marketing Carrier",
      "product": "Produto",
      "products": "Produtos",
      "products_inheritance": "Produtos Herdados",
      "products_inheritance_ut": "Produtos Herdados da Unidade de Trabalho",
      "products_inheritance_un": "Produtos Herdados da Unidade de Negócios",
      "dashboard": "Painel",
      "is_offline": "É offline",
      "children": "Filhos",
      "adults": "Adultos",
      "minors": "Menores",
      "layout": "Layout",
      "state": "Estado",
      "zip_code": "CEP",
      "id": "Id",
      "token": "Token",
      "token_parent": "Token Pai",
      "email": "Email",
      "short_name": "Nome curto",
      "long_name": "Nome longo",
      "business_type": "Tipo de negócio",
      "business_type_id": "Id de Tipo de negócio",
      "name": "Nome",
      "phone": "Telefone",
      "phone_number": "Número de telefone",
      "address": "Endereço",
      "region": "Região",
      "document_type": "Tipo de documento",
      "document_type_id": "ID Tipo de documento",
      "document_number": "Número de documento",
      "type_responsible": "Tipo de responsável",
      "manager_responsible": "Responsável Operacional",
      "commercial_responsible": "Responsável Comercial",
      "birthday": "Data de Nascimento",
      "description": "Descrição",
      "item_description": "Descrição do item",
      "contact": "Contato",
      "administrative_contact": "Contato administrativo",
      "fantasy_name": "Nome fantasia",
      "date_out": "Data de saída",
      "date_in": "Data de chegada",
      "date_emision": "Data de emissão",
      "symbol": "Símbolo",
      "color": "Cor",
      "ref_table_detail": "Tabela de detalhe",
      "create_at": "Criado",
      "update_at": "Atualizado",
      "work_unit": "Unidade de Trabalho",
      "work_unit_id": "Id da Unidade de Trabalho",
      "business_unit": "Unidade de negócio",
      "firstname": "Nome",
      "surname": "Sobrenome",
      "application": "Aplicação",
      "client": "Cliente",
      "role": "Papel",
      "hash_user": "Hash do usuário",
      "status_detail": "Status",
      "action": "Ação",
      "module": "Módulo",
      "entity": "Entidade",
      "application_id": "Id da Aplicação",
      "start_icon": "Ícone inicial",
      "permission": "Permissões",
      "menu": "Menu",
      "text": "Texto",
      "is_active": "Ativo",
      "is_not_active": "Inativo",
      "is_superadmin": "Superadmin",
      "is_staff": "Equipe",
      "is_admin": "Admin",
      "module_id": "Id do Módulo",
      "client_id": "Id do Cliente",
      "product_json": "Json de Produtos",
      "start_validity_rule": "Início vigência Regra",
      "expiration": "Expiração",
      "config": "Configuração",
      "end_validity_rule": "Fim vigência Regra",
      "username": "Usuário",
      "user_id": "Id do Usuário",
      "user": "Usuário",
      "password": "Senha",
      "value": "Valor",
      "tax_id": "Identificador Fiscal",
      "date_in_and_out": "Data de saída e chegada",
      "endpoint": "Recurso",
      "steps": "Passos",
      "flight_number": "Nº do voo",
      "airline": "Companhia aérea",
      "hotel": "Hotel",
      "item_id": "Id do item",
      "id_detail": "Id do detalhe",
      "parameters": "Parâmetros",
      "country_id": "Id do País",
      "country": "País",
      "countries": "Países",
      "city": "Cidade",
      "currencies": "Moedas",
      "currency_inheritance": "Moeda herdada",
      "code_iata": "Código IATA",
      "tma_code": "Código de Faturamento",
      "days_to_cancel": "Dias para cancelar",
      "autocancel": "Autocancelamento",
      "external_code": "Código externo",
      "vat_active": "IVA ativo",
      "gmx_contract_id": "Id Contrato GMX",
      "paste_json": "Inserir JSON",
      "select_default_json": "JSON padrão",
      "write_json_manually": "Escrever JSON manualmente",
      "json": "JSON",
      "invalid_json": "O JSON inserido não é válido",
      "invalid_formulas": "As fórmulas inseridas não são válidas",
      "tableName": "tableName",
      "api_endpoint": "Api Endpoint",
      "parent_workunit": "Unidade de Trabalho - Pai",
      "parent_businessunit": "Unidade de Negócio - Pai",
      "path": "path",
      "main": "Principal",
      "mapping": "Mapeamento",
      "settings": "Configuração",
      "fiscal_data": "Dados Fiscais",
      "is_agency": "Agência",
      "destination": "Destino",
      "destination_detail": "Detalhe do destino",
      "datetime_destination": "Data e hora do destino",
      "parent_businessRule": "Regra de Negócio - Pai",
      "rule_type": "Tipo de regra",
      "rule_liquidation_type": "Tipo de regra de liquidação",
      "destination_type": "Tipo de destino",
      "source": "Fonte",
      "payment": "Pago",
      "journal_entry": "Lançamento Contábil",
      "journal_entry_date": "Data do lançamento contábil",
      "provision": "Provisão",
      "provision_date": "Data da provisãon",
      "payments": "Pagado",
      "payment_types": "Tipos de pagamento",
      "payment_methods": "Métodos de pagamento",
      "payment_type": "Tipo de pagamento",
      "payment_method": "Método de pagamento Cartão",
      "payment_method_by_bank": "Método de pagamento Banco",
      "no_selected_var": "Nenhuma variável selecionada",
      "operators": "Operadores",
      "data": "Data",
      "variables": "Variáveis",
      "create_formula": "Criar fórmula",
      "formula": "Fórmula",
      "show_breakdown": "Mostrar no detalhamento",
      "show_sitio": "Mostrar no site",
      "show_breakdown_and_sitio": "Exibir detalhamento e no site",
      "flexi": "Flexi",
      "extra_baggage": "Extra bagagem",
      "checkin": "Check-in",
      "checkout": "Check-out",
      "concept": "Conceito",
      "amounts": "Valores",
      "amount": "Valor",
      "amount_pending": "Valor Pendente",
      "id_item": "Id do item",
      "id_reserva": "Id da Reserva",
      "booking_number": "Número da reserva",
      "item_number": "Número do item",
      "amount_to_pay": "Quantia a pagar",
      "date_time": "Data",
      "auth_code": "Autorização",
      "card_number": "Número do cartão",
      "expiry_date": "Data de validade",
      "cardholder": "Titular do cartão",
      "card_holder": "Titular do cartão",
      "issuing_bank": "Banco emissor",
      "quota": "Número de parcelas",
      "client_document_number": "Número do documento do cliente",
      "client_name": "Nome do cliente",
      "bank": "Banco",
      "destinationBank": "Banco de destino",
      "issuingBank": "Banco emissor",
      "cash": "Dinheiro",
      "type": "Tipo",
      "number": "Número",
      "initial_date": "Data inicial",
      "final_date": "Data de finalização",
      "bank_name": "Banco",
      "refundable": "Reembolsável",
      "route": "Rota",
      "reference": "Referência",
      "gateway": "Gateway de pagamento",
      "version_number": "Número da Versão",
      "modify_by": "Modificado por",
      "slug": "Slug",
      "account_number": "Número da conta",
      "parent_id": "Id Pai",
      "type_sum": "Soma",
      "financial_entity": "Entidade financeira",
      "card": "Cartão",
      "last_digit_card": "últimos 4 dígitos",
      "reservation_item": "itens da reserva",
      "passenger": "Passageiro",
      "titular_passenger": "Passageiro titular",
      "managerResponsible": "Responsável Operacional",
      "operations": "Operações",
      "operations_vietur": "Operações Vietur",
      "operation_type": "Tipo de operação",
      "amount_to_use": "Valor a ser utilizado",
      "reserve": "Reserva",
      "document": "Documento",
      "age": "Idade",
      "birth_date": "Data de nascimento",
      "is_titular": "É titular?",
      "extra": "extra",
      "external_id": "ID externo",
      "gds": "GDS",
      "id_issue_office": "Id do escritório de emissão",
      "transmitter": "emissor",
      "carryOnWeight": "Peso CarryOn",
      "handbag": "bolsa de mão",
      "unit": "Unidade",
      "weight": "Peso",
      "operator_company": "Companhia operadora",
      "booking_class": "Classe",
      "flight": "Voo",
      "fare_basis": "Fare Basis",
      "equipmentType": "Equipamento",
      "Cabin": "Cabine",
      "provider": "Fornecedor",
      "provider_code": "Código do fornecedor",
      "distribution": "Distribuição",
      "type_room": "Tipo de quarto",
      "regime": "Regime",
      "coverage": "Cobertura",
      "driver_name": "Nome do motorista",
      "driver_lastname": "Sobrenome do motorista",
      "driver_document": "Documento do motorista",
      "driver_age": "Idade do motorista",
      "car_name": "Nome do carro",
      "assistance_name": "Nome da assistência",
      "origin": "Origem",
      "origin_detail": "Detalhe da origem",
      "datetime_origin": "Data e hora de origem",
      "operatingCarrier": "Operating Carrier",
      "marketingCarrier": "Marketing Carrier",
      "marketingInformation": "Informação de Marketing",
      "business_name": "Nome comercial",
      "point_of_sale": "Pontos de venda",
      "segment_price": "Tarifa trecho",
      "booking_reference": "Referência de Reserva",
      "hold_distributor": "Data de Vencimento",
      "hash": "Hash",
      "priority": "Prioridade",
      "active_hours_to": "Fim da hora de ativação",
      "active_hours_from": "Início da hora de ativação",
      "active_days": "Dias ativos",
      "start_reservation_date": "Data de compra desde",
      "end_reservation_date": "Data de compra até",
      "start_service_date": "Data de início do serviço desde",
      "end_service_date": "Data de início do serviço até",
      "numbering_client": "Numeração Clientes",
      "numbering_reservation": "Numeração Reservas",
      "file_number": "Número do arquivo",
      "number_items": "Número do item",
      "total": "Total",
      "num_item_billing": "Número Item Faturamento",
      "invoice": "Fatura",
      "nro": "Nº",
      "invoice_id": "Id da fatura",
      "change_type": "Tipo de câmbio",
      "change_type_reversed": "Tipo de câmbio invertido",
      "receipt_number": "Número do Recibo",
      "cash_name": "Caixa",
      "client_document_type": "Tipo de documento",
      "origin_date": "Data",
      "vendor_code": "Cartão de crédito",
      "transaction": "Transação",
      "comision": "Comissão",
      "commission_paid": "Comissão cedida",
      "expenses": "Despesas Administrativas",
      "fare_amount": "Valor da tarifa",
      "fee": "Fee",
      "final_price": "Preço de venda",
      "iva": "Iva",
      "neto_factura": "Preço líquido Fatura",
      "total_factura": "Total Fatura",
      "neto_gravado_10_5": "Preço Líquido Tributável (10,5%)",
      "base_rg5617": "Base RG5617",
      "neto_exento": "Preço Líquido Isento",
      "neto_gravado_21": "Preço Líquido Tributável (21%)",
      "neto_no_gravado": "Preço Líquido Não Tributado",
      "neto_iva_no_corresponde": "Preço Iva Não Corresponde",
      "impuesto1": "Imposto 1",
      "markup": "Markup",
      "mark_up": "Markup",
      "optmzd_mrkup_amnt": "Otimização",
      "net_agency": "Preço líquido Agência",
      "net_price": "Preço líquido",
      "net_provider": "Líquido fornecedor",
      "over_amount": "Over",
      "taxes_amount": "Impostos",
      "product_type": "Tipo de produto",
      "renter": "Locadora",
      "date_origin_service": "Início do serviço",
      "date_destination_service": "Finalização do serviço",
      "pickup_origin": "Origem",
      "pickup_date": "Data e Hora",
      "pickup_type": "Detalhe Pickup",
      "pickup_destination": "Destino",
      "pickup_transfer_type": "Tipo de Traslado",
      "pickup_category": "Categoria",
      "pickup_vehicle": "Tipo de Veículo",
      "pnr": "Código PNR",
      "days_number": "Quantidade de dias",
      "donwload_voucher": "Baixar voucher",
      "commissionable_rate": "Tarifa comissionável",
      "non_commissionable_rate": "Tarifa Não Comissionável",
      "commission_percentage": "Percentual de comissão",
      "ancillary_pax_1": "Custo ancillary baggage",
      "additional_fare": "Adicional a pagar no destino",
      "net_price_by_car": "Total custo fornecedor",
      "nationality": "Nacionalidade",
      "residence_country": "País de residência",
      "receiver": "Receptor",
      "mail": "Email",
      "hashuser": "Hash do usuário",
      "hash_business_unit": "Hash unidade de negócio",
      "agency_id": "Id da agência",
      "pick_up": "Pick Up",
      "drop_off": "Drop Off",
      "check_in_pick_up": "Data Pickup",
      "check_in_drop_off": "Data Drop Off",
      "dropoff_type": "Detalhe Drop Off",
      "created_at": "Data de criação",
      "updated_at": "Data de modificação",
      "reservation_number": "Número da reserva",
      "service_detail": "Detalhe do serviço",
      "date_first_service": "Data do 1º serviço",
      "start_date_first_service": "Data do 1º serviço desde",
      "end_date_first_service": "Data do 1º serviço até",
      "start_create_date": "Data de criação desde",
      "end_create_date": "Data de criação até",
      "start_autocancel_date": "Data de autocancelamento desde",
      "end_autocancel_date": "Data de autocancelamento até",
      "start_last_modification_date": "Data de modificação desde",
      "end_last_modification_date": "Data de modificação até",
      "search_client": "Buscar cliente",
      "search_reservation": "Buscar reserva",
      "add_tags": "Adicionar etiquetas ao produto",
      "round_trip": "Pega e deixa no mesmo lugar",
      "add_transfer": "Adicionar traslado?",
      "detail_service": "Detalhe do serviço",
      "hash_booking_id": "Hash/Booking ID",
      "product-type": "Tipo de produto",
      "product-types": "Tipos de produto",
      "validity": "Validade",
      "from": "Desde",
      "to": "Até",
      "rate_type": "Tipo de tarifa",
      "ticketNumber": "Número do passe",
      "period_type": "Tipo de oferta",
      "duration": "Duração",
      "sample": "Amostra",
      "offline_product": "Permite carga Offline",
      "prefix": "Prefixo",
      "document_branch_number": "Número da filial",
      "last_used": "Último utilizado",
      "payment_status": "Status do pagamento",
      "reservation_status": "Status da reserva",
      "item_status": "Status de cada item",
      "num_pax": "Quantidade de passageiros",
      "num_segments": "Quantidade de trechos",
      "seat": "Assentos",
      "create_time": "Data de criação",
      "paypal_id": "Id do paypal",
      "payment_id": "Id do pagamento",
      "intent": "Motivo",
      "observation": "Observação",
      "origin_observation": "Observação de origem",
      "currency_to": "Moeda para",
      "currency_from": "Moeda de",
      "available_credits": "Créditos disponíveis",
      "credit_to_sum": "Créditos a somar",
      "limit_credit": "Limite de créditos",
      "has_credit": "Usa créditos",
      "gmx_segment_id": "Código Gimmonix",
      "is_berlin": "É berlin?",
      "setting_email": "Configuração de email",
      "logo": "Logo",
      "logo_voucher": "Logo voucher",
      "sale_number": "Referência Externa",
      "autocancel_date": "Data de autocancelamento",
      "primary_color": "Cor primária",
      "secondary_color": "Cor secundária",
      "folder_root": "Pasta raiz",
      "bcc_email": "BCC email",
      "transport": "Transporte",
      "mailer_from": "Mailer de",
      "mailer_host": "Mailer host",
      "mailer_user": "Mailer user",
      "mailer_password": "Mailer senha",
      "mailer_port": "Mailer porta",
      "use_tls": "Usar tls",
      "use_ssl": "Usar ssl",
      "header": "Cabeçalho",
      "subject": "Assunto",
      "greeting": "Saudação",
      "content": "Conteúdo",
      "footer": "Rodapé",
      "hash_value": "Hash",
      "notification": "Notificações",
      "seller_user": "Usuário vendedor",
      "last_update_date": "Data da última modificação",
      "tma_business": "Negócio TMA",
      "tags": "Etiquetas",
      "folder": "Pasta",
      "billing_status": "Status de faturamento",
      "billing_situation": "Status faturamento",
      "billing_situation_yes": "Faturado",
      "billing_situation_no": "NÃO Faturado",
      "additional_cost": "Custo adicional",
      "total_cost": "Custo Total",
      "current_password": "Senha atual",
      "new_password": "Nova senha",
      "confirm_new_password": "Confirmar nova senha",
      "credit_or_payment_type": "Crédito ou Tipo de pagamento",
      "apply_extra_cost": "Aplica Despesas",
      "amount_in_currency_to_pay": "Total na moeda de origem",
      "currency_pay": "Moeda de pagamento",
      "total_amount_in_currency_to_pay": "Total na moeda de pagamento",
      "pending_amount_in_currency_to_pay": "Pendente na moeda de pagamento",
      "amount_to_apply": "Valor a aplicar",
      "total_amount_billing": "Total Venda",
      "total_cost_billing": "Total Custo",
      "base": "Taxa de câmbio",
      "profit_percentage": "% Lucro",
      "item_descripcion": "Descrição do Item",
      "amount_paid": "Valor Pago",
      "pending_amount": "Pendente de pagamento",
      "have_credit": "Possui crédito",
      "amount_unused": "Valor não utilizado",
      "e_ticket": "E-Ticket",
      "in_reserve": "Em reserva",
      "marketing_carrier": "Marketing carrier",
      "addressee": "Destinatário",
      "email_sent": "Email enviado",
      "send_to": "Enviar para",
      "differentiated_change_type": "Tipo de câmbio diferenciado",
      "invoice_reference": "Referência da fatura",
      "receipt_reference": "Referência do recibo",
      "search_by": "Buscar por:",
      "type_of_service": "Tipo de Serviço",
      "condition": "Condição",
      "billing_base": "Base de Faturamento",
      "billing_default_base": "Base de Faturamento padrão",
      "billing_alternate_base": "Base(s) de Faturamento alternativa(s)",
      "start_billing_date": "Início Fatura Data",
      "end_billing_date": "Fim Fatura Data",
      "billing_date": "Data de Faturamento",
      "start_invoice_date": "Início Fatura Data",
      "end_invoice_date": "Fim Fatura Data",
      "invoice_date": "Data Fatura",
      "ticket_number": "Nº do ticket",
      "is_billable": "Pronto para faturar",
      "auto_bill": "Faturar automaticamente",
      "final_sale": "Total venda",
      "size_width": "Largura (px)",
      "size_height": "Altura (px)",
      "mobile_size_width": "Largura móvel (px)",
      "mobile_size_height": "Altura móvel (px)",
      "title": "Título",
      "button_text": "Texto do botão",
      "link_button": "Link do botão",
      "group": "Grupo",
      "html_content_additional": "Conteúdo HTML adicional",
      "meta": "Meta",
      "link": "Link",
      "datetime_from": "Data desde",
      "datetime_to": "Data até",
      "html_content": "Conteúdo HTML",
      "flow": "Flow",
      "order": "Ordem",
      "site_type": "Tipo de site",
      "category": "Categoria",
      "banner_type": "Tipo de banner",
      "image": "Imagem",
      "mobile_image": "Imagem móvel",
      "banner": "Banner",
      "label": "Etiqueta",
      "caption": "Legenda",
      "url": "URL",
      "base_to_billing": "Base para faturamento",
      "menu_visible": "Menu visível",
      "form_visible": "Formulário visível",
      "newsletter_visible": "Newsletter visível",
      "default_form": "Formulário padrão",
      "sector_type": "Tipo de setor",
      "banners": "Banners",
      "sector": "Setor",
      "html": "HTML",
      "setting_html": "Configurar HTML",
      "see_html": "Ver HTML",
      "billing": "Faturamento",
      "landing": "Landing",
      "auto_billable": "Faturamento automático",
      "amount_compensated": "Valor a compensar em %{currency}",
      "amount_pending_in": "Valor Pendente em %{currency}",
      "amount_pending_to_pay_in": "Valor Pendente a pagar em %{currency}",
      "liquidation_type": "Tipo de liquidação",
      "login_required": "Login necessário",
      "index_required": "Indexar",
      "payment_date": "Data de Pagamento",
      "apply_total_in_order": "Aplicar por ordem",
      "apply_total_equitably": "Aplicar equitativamente",
      "work_unit_long_name": "Nome longo da unidade de trabalho",
      "work_unit_short_name": "Nome curto da unidade de trabalho",
      "billing_automatic": "Faturamento automático",
      "create_at_date": "Data de Criação",
      "formula_global_variables": "Variáveis globais",
      "textColor": "Cor do texto",
      "backgroundColor": "Cor de fundo",
      "ticket_type": "Tipo de ticket",
      "check_type": "Tipo de cheque",
      "is_emd": "É EMD",
      "sale_discount": "Desconto de venda",
      "taxes_1": "Imposto 1",
      "taxes_2": "Imposto 2",
      "taxes_3": "Imposto 3",
      "cabotage": "Cabotagem",
      "fare_code": "Tarifa Adicional",
      "method_pay_uatp": "UATP",
      "complete_client_name": "Nome e Sobrenome do Titular do cartão",
      "agency_auth_code": "Autorização",
      "authorization_code": "Código de Autorização",
      "payment_id_braspag": "Identificador no Braspag",
      "braspag_id": "Identificador Braspag",
      "card_brand_id": "Identificador da Marca do Cartão",
      "customer_email": "E-mail do Cliente",
      "customer_birth": "Data de Nascimento do Cliente",
      "customer_street": "Endereço do Cliente",
      "customer_city": "Cidade do Cliente",
      "customer_district": "Distrito do Cliente",
      "child": "Criança",
      "adult": "Adulto",
      "infant": "Bebê",
      "due_date_final": "Data estendida",
      "start_due_date": "Pagamento devido Desde",
      "end_due_date": "Pagamento devido Até",
      "due_date": "Pagamento devido",
      "accounting_date": "Data de contabilização",
      "days": "Dias",
      "due-date-range": "Intervalo de Data de Vencimento",
      "date_ranges": "Período",
      "holder": "Titular",
      "passenger_type": "Tipo de passageiro",
      "paypal_create_time": "Data de criação",
      "exclude_product": "Excluir produto",
      "applications": "Aplicações",
      "price_logic": "Lógica de preço",
      "json_product": "JSON DE PRODUCTOS",
      "detail_table": "TABELA DE DETALHES",
      "language": "Idioma",
      "due_date_method": "Modelo de data de vencimento",
      "expirations": "Vencimentos",
      "determining_date": "Data Determinante",
      "application_date": "Fecha de Aplicação",
      "customer_info": "Dados do cliente",
      "customer_number": "Número do Cliente",
      "customer_state": "Estado do Cliente",
      "customer_country": "Pais del cliente",
      "customer_zip_code": "CEP do Cliente",
      "customer_complement": "Complementar do Cliente",
      "installments": "Cotas",
      "card_brand_name": "Cartão",
      "ref_site": "Referência para o site",
      "item_billing_status": "Status de faturamento do item",
      "status_fraud": "Análise de Fraude",
      "my_device_computer": "computador",
      "my_device_phone": "telefone",
      "browser": "Navegador",
      "last_active": "Última vez ativo",
      "unknown": "um estranho",
      "tx_id": "Transação",
      "order_id": "ID do pedido",
      "customer_document_type": "Tipo de documento",
      "customer_document_value": "Número do documento",
      "customer_name": "Nome",
      "has_retention": "Tem Retenção",
      "retention_type": "Tipo de Retenção",
      "retention_amount": "Valor da Retenção",
      "retention_certificate": "Número do Certificado",
      "amount_used": "Quantidade usada",
      "payer_CUITCUIL": "CUIT/CUIL do pagador",
      "reservationNumber": "N° de reserva",
      "removeReservation": "Remover",
      "totalAmount": "Valor total",
      "paidAmount": "Valor pago",
      "pendingAmount": "Valor pendente",
      "paymentMethod": "Forma de pagamento",
      "otherAmount": "Outro valor",
      "declaredTotal": "Total declarado",
      "selectedTotal": "Total selecionado",
      "finalBalance": "Saldo final",
      "supplierCode": "Código do fornecedor",
      "month": "Mês",
      "currencyType": "Tipo de moeda",
      "isInherited": "É herdado",
      "allocation_message": "Mensagem de imputação",
      "operation_id": "ID da operação",
      "journal_id": "ID do assento",
      "journal": "Journal",
      "hepstar_status": "Estado Hepstar",
      "hepstar_code": "Código Hepstar",
      "hepstar_product": "Produto Hepstar",
      "hepstar_product_airhelp": "Compensação AirHelp",
      "hepstar_product_cfar": "Cancelamento por Qualquer Motivo",
      "hepstar_product_refundable": "Cancelamento por Motivos Específicos",
      "hepstar_product_smartdelay": "SmartDelay",
      "hepstar_product_traceme": "Proteção por Perda de Bagagem",
      "hepstar_product_esim": "eSIM",
      "general_state": "Estado Geral",
      "flow_status": "Estado do Fluxo",
      "company": "Companhia",
      "commerce_number": "Número de Comércio",
      "display": "Display",
      "terminal": "Terminal",
      "client_code": "Código do cliente",
      "pyment_attempts": "Tentativas de pagamento",
      "error_detail": "Detalhe do erro",
      "payment_detail": "Detalhe do pagamento",
      "error_code": "Código de erro",
      "session_expired": "Sessão expirada",
      "fraud_id": "ID de fraude",
      "emission_status": "Status de emissão",
      "abandon_instance": "Instância de abandono",
      "fraud_detail": "Detalhe da fraude",
      "route_type": "Tipo de rota",
      "device": "Dispositivo",
      "start_validity": "Início vigência",
      "end_validity": "Fim vigência",
      "last_update": "Última atualização",
      "coef": "Coeficiente",
      "card_type": "Tipo de cartão",
      "include_route": "Rotas incluídas",
      "exclude_route": "Rotas excluídas",
      "exclude_airlines": "Companhias aéreas excluídas",
      "only_airline": "Companhia aérea única",
      "business": "Negócios",
      "site_label": "Etiqueta do site",
      "seat_selection": "Seleção de assento",
      "food": "Comida",
      "changes": "Alterações",
      "refoundable": "Reembolso",
      "all_devices": "Dispositivos",
      "meta_code": "Meta code",
      "meta_info": "Metadata",
      "medium": "Meio",
      "campaign": "Campanha",
      "sessid": "Sessid",
      "tcid": "Tcid",
      "term": "Term",
      "comments": "Comentários",
      "message": "mensagem",
      "amount_refunded": "Penalidade do reembolso",
      "accounting_config_code": "Configuração de contabilidade",
      "supplier_type": "tipo de fornecedor",
      "creation_user": "Usuário de criação",
      "assigned": "Alocado",
      "message_type": "Tipo de mensagem",
      "for": "Para",
      "follower": "Seguidor",
      "assign_item": "Atribuir item",
      "task_role": "Papel da tarefa",
      "template": "Modelo",
      "total_to_return": "valor a ser devolvido",
      "reserve_nrf": "Reserva Non Ref",
      "documents": "Documentos",
      "charged": "Cobrado",
      "credit_balance": "Saldo a favor",
      "billable_exchange_rate": "Taxa de câmbio faturável",
      "retention": "Retenção",
      "bad_practice": "Má prática",
      "debit": "Débito",
      "transaction_date": "Data do movimento",
      "parent_long_name": "Nome longo del Pai",
      "parent_short_name": "Nome curto del Pai",
      "parent_fiscal_data_name": "Dados Fiscais del Pai",
      "online_payments": "Pagamentos online",
      "add_payment_instance": "Adicionar instância de pagamento",
      "weekly_availability": "Disponibilidade semanal",
      "supplier_due_date": "Data de vencimento do fornecedor",
      "aditional_recipients": "Destinatários adicionais",
      "creator": "Criador",
      "internal_code": "Código interno",
      "subtype": "Subtipo",
      "date_type": "Tipo de datas",
      "sending_frequency": "Frequência de envio",
      "analysis_period": "Período de análise",
      "payment_due_date": "Data de vencimento de pagamento",
      "first_service_date": "Data do 1º serviço",
      "recipients": "Destinatários",
      "frequency": "Frequência",
      "frequencies": "Frequências",
      "flexi_amnt": "Flexible valor",
      "item_create_date": "Data de criação do item",
      "reserve_create_date": "Data de criação da reserva",
      "custom": "Personalizado",
      "overdue_balance": "Saldo vencido",
      "balance_due": "Saldo a vencer",
      "item_ticket_number": "Número do bilhete aéreo",
      "gateway_expenses": "Despesas de gateway",
      "end_date": "Data de Conclusão",
      "receipt_generated": "Recibo gerado",
      "form": "Formulário",
      "interest_display": "Exibição de juros",
      "fraud_review": "Revisão Fraude",
      "rebooker": "Rebooker",
      "disable_rebooker": "Rebook desativado",
      "days_to_rebook": "Dias para rebookear",
      "markup_additional": "Markup adicional",
      "currency_value": "Valor da moeda",
      "type_determination_date": "Tipo de data determinante",
      "hepstar": "Hepstar",
      "start_date": "Data de início",
      "debit_note": "Nota de débito",
      "credit_note": "Nota de crédito",
      "voucher_date": "Data do comprovante",
      "tour_id": "Tour ID",
      "aditional_information": "Detalhes do itinerário",
      "day": "Dia",
      "cities": "Cidades",
      "optional_services": "Serviços opcionais",
      "optional": "Opcional",
      "quantity": "Quantidade",
      "price": "Preço",
      "tax": "Imposto",
      "operator": "Operador do circuito",
      "start_city": "Cidade de início",
      "end_city": "Cidade de finalização",
      "included": "Inclui",
      "not_included": "Não inclui",
      "provided_hotels": "Hotéis previstos ou similares",
      "detail": "Detalhe",
      "segment_count": "Quantidade de trechos",
      "passener_count": "Quantidade de passageiros",
      "provider_codes": "Códigos do provedor",
      "carriers": "Transportadoras",
      "operating_carrier": "Transportadora operadora",
      "total_amount": "Valor total",
      "card_brand": "Bandeira do cartão",
      "payment_attempts": "Tentativas de pagamento",
      "payment_gateway": "Gateway de pagamento",
      "created_log": "Data de criação do log",
      "kid_age": "Idade da criança",
      "kid_weight": "Peso da criança",
      "Only_hand_bags?": "Apenas bagagem de mão",
      "supplier_expense_date": "Data de Entrada em Despesas do Fornecedor",
      "has_receipt": "Tem recibo",
      "is_conciliable": "Conciliável",
      "is_private": "Privado",
      "no_conciled": "No conciliado",
      "passenger_count": "Quantidade de passageiros",
      "expiration_date": "Validade do Passaporte",
      "support_reason": "Motivo do suporte",
      "resolution": "Resolução",
      "exclusive_use": "Uso exclusivo Tecnologia",
      "timezone": "Fuso horário",
      "commercial_terms": "Condições comerciais",
      "product_line": "Linha de produto",
      "nrf_book": "Reserva Non Ref",
      "show_supplier": "Mostrar fornecedor",
      "pw_action_travel": "Action Travel",
      "tma": "TMA",
      "REDMINE": "Redmine",
      "redmine_superadmin": "Redmine Superadmin",
      "fiscal_address": "Endereço fiscal",
      "total_price": "Preço total",
      "total_passengers": "Total de passageiros",
      "payment_policy": "Política de pagamento",
      "billing_code": "Código de faturamento",
      "item_currency": "Moeda da fatura",
      "invoice_currency": "Moeda do item",
      "retail": "Varejo",
      "wholesaler": "Atacadista",
      "global_variable": "Variável global",
      "show_breakdown_global_variable": "Exibir variável global no detalhamento",
      "rule_short": "Rg.",
      "rule_price_short": "Rg. Preço",
      "fiscal_number": "Número de identificação fiscal",
      "number_journal_entry": "Nº do assento",
      "login": "Login",
      "file": "Arquivo",
      "exchange_b2": "Taxa B2",
      "exchange_invoice": "Taxa fatura",
      "promo": "Promo",
      "promotion": "Promoção",
      "payment_method_filter": "Método de pagamento",
      "payment_select": "Selecione",
      "smartbookTitle": "Smartbook",
      "days_of_week": "Dias da semana",
      "promotion_name": "Nome da Promoção",
      "site_description": "Descrição no site",
      "apply_coupon": "Aplicar cupom",
      "coupon_code": "Código do cupom",
      "total_quantity": "Quantidade total",
      "required_services": "Serviços necessários (opcional)",
      "application_value": "Valor de aplicação",
      "product_type_aereos": "Aéreos",
      "product_type_asistencia": "Assistência",
      "product_type_autos": "Carros",
      "product_type_hoteles": "Hotéis",
      "product_type_trenes": "Trens",
      "service_flexible": "Flexível",
      "service_branded_fare": "Branded Fare",
      "service_extra_baggage": "Bagagem Extra",
      "service_hepstar": "Hepstar",
      "service_premium_package": "Pacote Premium",
      "application_base_fare": "Tarifa Base",
      "application_base_fare_taxes": "Tarifa Base + Impostos",
      "application_base_fare_taxes_charges": "Tarifa Base + Impostos + Encargos",
      "application_total_amount": "Valor Total",
      "application_flexi": "Flexi",
      "application_service_package": "Pacote Premium",
      "range_currency": "Moeda da faixa",
      "ranges": "Faixas",
      "discount": "Desconto",
      "cap": "Limite",
      "add_range": "Adicionar faixa",
      "fixed_amount": "Valor fixo",
      "percentage": "Porcentagem",
      "validity_start": "Início da Vigência",
      "validity_end": "Fim da Vigência",
      "service_start_from": "Início do serviço desde (opcional)",
      "service_end_to": "Fim do serviço até (opcional)",
      "site_currency": "Moeda do site",
      "payment_method_optional": "Método de pagamento (opcional)",
      "promotion_conditions": "Condições da promoção (opcional)",
      "all": "Todas",
      "credit_card": "Cartão de crédito",
      "debit_card": "Cartão de débito",
      "debin": "Debin",
      "deposit": "Depósito",
      "transfer": "Transferência",
      "redirect_url_placeholder": "Digite a URL de redirecionamento",
      "validity_from": "Válido Desde",
      "validity_to": "Válido Até",
      "uses": "Usos",
      "stock_total": "Estoque Total",
      "promo_1": "Desconto promo 1",
      "promo_2": "Desconto promo 2",
      "customer_province": "Província",
      "installments_gateway": "Cotas gateway",
      "session_closed": "Sessão fechada",
      "amount_meta": "Taxa Meta",
      "availability": "Disponibilidade",
      "purchase_code": "Código de compra",
      "amount_earned": "Valor acumulado",
      "extra_cost_amnt": "Custo de serviços adicionais",
      "extra_sale_amnt": "Venda de serviços adicionais",
      "manual_ancillary_cost_amnt": "Custo ancillary manual",
      "manual_ancillary_sale_amnt": "Venda ancillary manual"
    },
    "backend_error": {
      "not_credit": "por Crédito Insuficiente"
    },
    "tooltip": {
      "change_status_to_cancel": "Esta ação só mudará o status para cancelado",
      "change_status_to_invoiced": "Esta ação só mudará o status para emitido",
      "separateReservationsForMultiSearch": "Separe as reservas por vírgulas para pesquisa múltipla",
      "gateway_installment": "Gateway através do qual será processado o pagamento à empresa",
      "site_label_installment": "Usado para refletir informações relacionadas ao financiamento do site",
      "order_installment": "Priorização de financiamento no local",
      "routes_installment": "Utilizado para financiamento aplicável apenas a rotas específicas. Use códigos IATA separados por hífen e vírgula sem espaço quando houver mais de um. Exemplo: EZE-MAD,MAD-EZE",
      "exclude_airlines_installment": "Usado para excluir códigos de companhias aéreas específicas que não se aplicam a financiamento",
      "only_airline_installment": "Ativar opção quando o financiamento for válido apenas para voos operados pela companhia aérea indicada no campo \"Empresa\"",
      "installments": "Quantidade de cotas exibidas no site.",
      "installments_gateway": "Quantidade de cotas para processamento na plataforma de pagamento.",
      "coef_installment": "O custo resultante da aplicação deste coeficiente é repassado ao cliente no local.",
      "expense_installment": "Campo utilizado para cálculo do custo interno do financiamento, repassado ou não ao cliente.",
      "unify_coef_installment": "Se o custo do financiamento estiver ativado, ele será exibido no site unificado em Encargos, caso contrário será discriminado em uma linha separada de Juros no detalhe do preço.",
      "bines_installment": "Caso o financiamento se aplique apenas a determinados itens, indique-o nesta seção separado por vírgula e sem espaço.",
      "cft_installment": "Texto livre. Informações a serem exibidas no site.",
      "tea_installment": "Texto livre. Informações a serem exibidas no site.",
      "refund_installment": "Texto livre. Informações a serem exibidas no site.",
      "promotion_name": "Campo de texto livre que permite identificar a promoção dentro da lista de promoções.",
      "site_description": "Legenda que será exibida no carrinho de compras para mostrar o desconto quando o cupom/promo for aplicado no site.",
      "apply_coupon": "Se ativado, isso indica que a promoção é em si um CUPOM e deve ser inserido no site para que o desconto seja aplicado. Além disso, será necessário indicar o Código do cupom que deseja criar e a Quantidade Total original disponível. Se este último campo for deixado vazio, considera-se que o estoque para seu uso é ilimitado, caso contrário complete com o total desejado.",
      "work_unit": "Unidade de Trabalho para a qual a promoção se aplica. Se desejar escolher mais de uma Unidade de Trabalho, só poderão ser selecionadas aquelas que estejam no mesmo nível hierárquico. Não é possível combinar Unidades de Trabalho Pais com Filhas, para isso será necessária a criação de uma promoção adicional.",
      "product_type": "Produto online principal ao qual a promoção se aplica",
      "airline_code": "Se desejar criar uma promoção válida apenas para voos de uma ou mais companhias aéreas, selecione-as na lista; caso contrário se aplicará a todas elas.",
      "destination_type": "Se desejar criar uma promoção válida apenas para voos \"Nacionais\" ou \"Internacionais\", selecione a opção desejada na lista; caso contrário se aplicará a todos eles.",
      "required_services": "Caso queira determinar a seleção de um serviço como obrigatória para a aplicação da promoção, deverá ser selecionado na lista; caso contrário o sistema não valida a seleção do serviço adicional. Isso define a mensagem exibida no site para orientar o cliente de que ele deve adicionar esse serviço para que o desconto se aplique.",
      "application_value": "Refere-se ao valor sobre o qual o benefício será aplicado.",
      "discount_ranges": "Nesta seção são definidas as faixas de aplicação do desconto. Será necessário primeiro inserir a Moeda da faixa, que define a moeda dos valores indicados nas faixas. Não há limite para criação de faixas. Se a promoção for aplicada sem um mínimo, insira 0 no campo De da primeira faixa. Use o campo Até para definir o máximo da faixa. Use o campo Tipo para indicar se o desconto a ser concedido é um valor fixo ou uma porcentagem e insira o valor no campo Desconto para defini-lo. Você pode usar o campo Limite caso queira limitar o desconto resultante oferecido se seu cálculo for percentual.",
      "validity_start": "Selecione a data de início da Promoção.",
      "validity_end": "Selecione a data de término da Promoção.",
      "starts_at": "Campo disponível para indicar que a promoção só se aplica a serviços que iniciem a partir de determinada data.",
      "ends_at": "Campo disponível para indicar que a promoção só se aplica a serviços que terminem antes de determinada data.",
      "site_currency": "Permite limitar a aplicação da promoção a uma determinada moeda no fluxo online. Importante: Caso seja escolhido um Tipo de Destino \"Nacional\", a única moeda disponível será ARS no caso de sites na Argentina.",
      "payment_method": "Permitirá especificar o(s) método(s) de pagamento para os quais o desconto será aplicado. Não preencha se desejar que o desconto se aplique a todos os métodos de pagamento.",
      "terms_and_conditions": "Campo de texto livre opcional para especificar URL que redireciona para as condições da promoção. Este campo é um link para associar a promoção criada através do B2 com os termos e condições especificados pelo Marketing."
    },
    "language": {
      "english": "Inglês",
      "spanish": "Espanhol",
      "pt_br": "Português (Brasil)"
    },
    "rule_type": {
      "PRICE": "Regra de Preço",
      "LIQUIDATION": "Regra de Liquidação",
      "BILLING": "Regra de Faturamento",
      "PAYMENT_CHARGE": "Regra de Cobrança",
      "SETTING": "Regra de Configuração",
      "CONTENT": "Regra de Conteúdo",
      "PAYMENT_METHOD": "Regra de Métodos de Pagamento",
      "INSTALLMENT": "Regra de Financiamento"
    },
    "destination_type": {
      "all": "Todos",
      "national": "Nacional",
      "international": "Internacional"
    },
    "card_type": {
      "credito": "Crédito",
      "debito": "Débito"
    },
    "baggage_type": {
      "small_baggage_title": "Inclui uma mochila ou bolsa",
      "small_baggage_description": "Deve caber embaixo do banco dianteiro.",
      "medium_baggage_title": "Inclui bagagem de mão",
      "medium_baggage_description": "Deve caber no compartimento superior do avião.",
      "medium_baggage_not_included": "Não inclui bagagem de mão",
      "large_baggage_not_included": "Não inclui bagagem para envio",
      "large_baggage_included": "Inclui bagagem para enviar"
    },
    "legend": {
      "show_sitio": "Visível no site",
      "show_breakdown": "Visível no detalhamento",
      "show_global_variable": "Variável global não visível",
      "show_breakdown_and_sitio": "Visível no detalhamento e no site",
      "show_breakdown_global_variable": "Variável global visível",
      "show_liquidation_retail": "Visível em Liquidação no Varejo",
      "show_liquidation_wholesaler": "Visível em Liquidação no Atacado",
      "show_liquidation_supplier": "Visível na Liquidação com Fornecedores",
      "global_variable_indicator": "Variável global"
    }
  }
}

export default languageObj
